<template>
  <div class="pc-login-page wap-login-page" :class="{ 'is-submitting': loadingLogin, 'is-reset': update_pwd == 1 }" @click="start_choose = false">
    <div class="login-language">
      <a-dropdown :trigger="['click']">
        <div class="language-trigger" @click.stop>
          <img class="language-icon" src="@/assets/wap/login-language@2x.png" alt="" />
          <span>{{ languageName }}</span>
          <img class="language-open" src="@/assets/wap/open.png" alt="" />
        </div>
        <a-menu slot="overlay" class="login-language-menu" @click="handleLanguage">
          <a-menu-item
            v-for="item in languageList"
            :key="item.id"
            :class="{ selected: item.id == languageId }"
          >
            {{ item.label }}
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>

    <div class="login-frame" :class="{ 'reset-frame': update_pwd == 1 }">
      <section ref="loginPanel" class="login-panel" :class="{ 'is-reset': update_pwd == 1 }">
        <div v-if="update_pwd == 0" class="login-logo">
          <img src="@/assets/wap/login-logo@2x.png" alt="viwoods" />
        </div>

        <div v-if="update_pwd == 0" class="login-main" :class="{ 'is-submitting': loadingLogin }">
          <h1>{{ pageTitle }}</h1>
          <p class="login-subtitle">{{ loginSubtitle }}</p>

          <a-form-model ref="loginFormModel" :model="userInfo" :rules="rules" class="login-form">
          <a-form-model-item prop="email" v-if="type == 1">
            <div class="clearable-field">
              <a-input
                v-model="userInfo.email"
                class="login-input"
                :placeholder="emailPlaceholder"
                :max-length="inputMaxLength"
                :disabled="loadingLogin"
                @change="clearErr"
                @keyup.enter="handleLogin"
              />
              <button v-if="userInfo.email" class="input-clear" type="button" aria-label="Clear" :disabled="loadingLogin" @click.stop="clearUserField('email')"></button>
            </div>
          </a-form-model-item>

          <a-form-model-item prop="phone" v-if="type == 2">
            <div class="phone-field" :class="{ focused: phoneFocused }">
              <button class="area-code" type="button" :disabled="loadingLogin" @click.stop="change_start_choose">
                <span>{{ userInfo.areaCode ? userInfo.areaCode : areaCodePlaceholder }}</span>
                <span class="area-arrow" :class="{ open: start_choose }"></span>
              </button>
              <div v-if="start_choose" class="area-options">
                <div
                  v-for="code in areaCodes"
                  :key="code.name"
                  class="area-option"
                  @click.stop="changeAreaCode(code)"
                >
                  <span class="area-country">
                    <img :src="code.img" alt="" />
                    <span>{{ code.enName }} ({{ code.name }})</span>
                  </span>
                  <span>{{ code.areaCode }}</span>
                </div>
              </div>
              <a-input
                v-model="userInfo.phone"
                class="login-input phone-input"
                :placeholder="phonePlaceholder"
                :max-length="inputMaxLength"
                :disabled="loadingLogin"
                @focus="phoneFocused = true; start_choose = false"
                @blur="phoneFocused = false"
                @keyup.enter="handleLogin"
                @change="changePhone"
              />
              <button v-if="userInfo.phone" class="input-clear" type="button" aria-label="Clear" :disabled="loadingLogin" @click.stop="clearUserField('phone')"></button>
            </div>
          </a-form-model-item>

          <a-form-model-item prop="password" v-if="sms_login == false">
            <div class="clearable-field clearable-password-field" :class="{ 'password-field-focused': loginPasswordFocused }">
              <a-input-password
                v-model="userInfo.password"
                class="login-input password-input"
                :placeholder="passwordPlaceholder"
                :max-length="inputMaxLength"
                :disabled="loadingLogin"
                @focus="loginPasswordFocused = true"
                @blur="loginPasswordFocused = false"
                @keyup.enter="handleLogin"
                @change="clearErr"
              />
              <button v-if="userInfo.password" class="input-clear" type="button" aria-label="Clear" :disabled="loadingLogin" @click.stop="clearUserField('password')"></button>
            </div>
          </a-form-model-item>

          <a-form-model-item prop="code" v-if="type == 2 && sms_login == true">
            <div class="code-field">
              <div class="clearable-field code-input-field">
                <a-input
                  v-model="userInfo.code"
                  class="login-input"
                  :placeholder="verificationPlaceholder"
                  :max-length="inputMaxLength"
                  :disabled="loadingLogin"
                  @focus="start_choose = false"
                  @change="clearErr"
                />
                <button v-if="userInfo.code" class="input-clear" type="button" aria-label="Clear" :disabled="loadingLogin" @click.stop="clearUserField('code')"></button>
              </div>
              <button class="send-code" type="button" :disabled="loadingLogin" @click.stop="getCode">
                <span v-if="is_send == 0 && reSendTime <= 0">{{ ll[languageId].verification_code }}</span>
                <span v-if="is_send == 1">{{ ll[languageId].sending }}</span>
                <span v-if="is_send == 2 && reSendTime > 0">{{ reSendTime }}s</span>
                <span v-if="is_send == 2 && reSendTime <= 0">{{ ll[languageId].reSend }}</span>
              </button>
            </div>
          </a-form-model-item>

          <div class="form-meta">
            <button v-if="sms_login == false" class="text-button" type="button" :disabled="loadingLogin" @click.stop="openResetPassword">
              {{ forgotText }}
            </button>
            <span v-else></span>
          </div>

          <div class="human-check" :class="{ verified: captchaVerified, dragging: captchaDragging }">
            <div class="human-track" ref="captchaTrack">
              <div class="human-fill" :style="{ width: captchaFillWidth + 'px' }"></div>
              <div class="human-text">{{ captchaText }}</div>
              <button
                class="human-handle"
                type="button"
                :disabled="loadingLogin"
                :style="{ transform: 'translateX(' + captchaOffset + 'px)' }"
                @mousedown.stop="startCaptchaDrag"
                @touchstart.stop.prevent="startCaptchaDrag"
              >
                <span v-if="!captchaVerified" class="human-arrow" aria-hidden="true">
                  <svg viewBox="0 0 16 16" focusable="false">
                    <path d="M1.5 8H13.8M9.2 3.8L13.8 8L9.2 12.2" />
                  </svg>
                </span>
                <span v-if="captchaVerified" class="human-check-icon"></span>
              </button>
            </div>
          </div>

          <a-form-model-item class="submit-item">
            <a-button
              class="login-submit"
              type="primary"
              :disabled="!canSubmitLogin || loadingLogin"
              :class="{ ready: canSubmitLogin, 'is-loading': loadingLogin }"
              @click.stop="handleLogin"
            >
              <span class="login-submit-label">
                {{ canSubmitLogin ? loginText : disabledLoginText }}
                <span v-if="loadingLogin" class="login-submit-spinner" aria-hidden="true"></span>
              </span>
            </a-button>
          </a-form-model-item>

          <div class="divider">
            <span></span>
            <em>{{ orText }}</em>
            <span></span>
          </div>

          <button class="switch-login" type="button" :disabled="loadingLogin" @click.stop="switchLoginType">
            {{ switchLoginText }}
          </button>

          </a-form-model>

          <p class="register-tip">{{ registerTip }}</p>
        </div>

        <div v-if="update_pwd == 1" class="reset-panel" :class="{ 'is-submitting': resetBusy }">
          <button class="reset-back" type="button" :disabled="resetBusy" @click.stop="resetGoBack">
            <span></span>
            {{ resetText.back }}
          </button>

          <div v-if="resetStep == 'account'" class="reset-main reset-account">
            <h1>{{ resetText.title }}</h1>
            <p class="login-subtitle">{{ resetAccountSubtitle }}</p>

            <div v-if="resetMode == 'phone'" ref="resetPhoneField" class="phone-field reset-field" :class="{ focused: resetPhoneFocused }">
              <button class="area-code" type="button" :disabled="resetBusy" @click.stop="change_start_choose">
                <span>{{ resetForm.areaCode ? resetForm.areaCode : areaCodePlaceholder }}</span>
                <span class="area-arrow" :class="{ open: start_choose }"></span>
              </button>
              <div v-if="start_choose" class="area-options" :style="resetAreaOptionsStyle">
                <div
                  v-for="code in areaCodes"
                  :key="code.name"
                  class="area-option"
                  @click.stop="changeResetAreaCode(code)"
                >
                  <span class="area-country">
                    <img :src="code.img" alt="" />
                    <span>{{ code.enName }} ({{ code.name }})</span>
                  </span>
                  <span>{{ code.areaCode }}</span>
                </div>
              </div>
              <a-input
                v-model="resetForm.phone"
                class="login-input phone-input"
                :placeholder="resetText.phonePlaceholder"
                :max-length="inputMaxLength"
                :disabled="resetBusy"
                @focus="resetPhoneFocused = true"
                @blur="resetPhoneFocused = false"
                @keyup.enter="sendResetCode"
              />
              <button v-if="resetForm.phone" class="input-clear" type="button" aria-label="Clear" :disabled="resetBusy" @click.stop="clearResetField('phone')"></button>
            </div>

            <div v-if="resetMode == 'email'" class="clearable-field reset-field">
              <a-input
                v-model="resetForm.email"
                class="login-input"
                :placeholder="resetText.emailPlaceholder"
                :max-length="inputMaxLength"
                :disabled="resetBusy"
                @keyup.enter="sendResetCode"
              />
              <button v-if="resetForm.email" class="input-clear" type="button" aria-label="Clear" :disabled="resetBusy" @click.stop="clearResetField('email')"></button>
            </div>

            <a-button
              class="login-submit reset-submit"
              type="primary"
              :class="{ ready: canSubmitResetAccount, 'is-loading': resetBusy }"
              :disabled="!canSubmitResetAccount || resetBusy"
              @click.stop="sendResetCode"
            >
              <span class="login-submit-label">
                {{ resetText.continue }}
                <span v-if="resetBusy" class="login-submit-spinner" aria-hidden="true"></span>
              </span>
            </a-button>

            <div class="divider reset-divider">
              <span></span>
              <em>{{ resetOrText }}</em>
              <span></span>
            </div>

            <button class="switch-login reset-switch" type="button" :disabled="resetBusy" @click.stop="switchResetMode(resetMode == 'phone' ? 'email' : 'phone')">
              {{ resetMode == 'phone' ? resetText.emailReset : resetText.phoneReset }}
            </button>

            <button class="reset-login-link" type="button" :disabled="resetBusy" @click.stop="returnToLogin">
              <span class="reset-login-prefix">{{ resetReturnLoginParts.prefix }}</span><span class="reset-login-action">{{ resetReturnLoginParts.action }}</span><span class="reset-login-prefix">{{ resetReturnLoginParts.suffix }}</span>
            </button>
          </div>

          <div v-if="resetStep == 'code'" class="reset-main reset-code">
            <h1>{{ resetText.codeTitle }}</h1>
            <p class="login-subtitle">{{ resetCodeSubtitle }}</p>

            <div class="code-field reset-field">
              <div class="clearable-field code-input-field">
                <a-input
                  v-model="resetForm.code"
                  class="login-input"
                  :placeholder="resetText.codePlaceholder"
                  :max-length="inputMaxLength"
                  :disabled="resetBusy"
                  @keyup.enter="checkResetCode"
                />
                <button v-if="resetForm.code" class="input-clear" type="button" aria-label="Clear" :disabled="resetBusy" @click.stop="clearResetField('code')"></button>
              </div>
            </div>
            <button class="reset-resend" type="button" :disabled="resetBusy || resetReSendTime > 0" @click.stop="sendResetCode">
              <span v-if="resetSending">{{ resetText.sending }}</span>
              <span v-else-if="resetReSendTime > 0">{{ resetReSendTime }}s {{ resetText.resendAfter }}</span>
              <span v-else>{{ resetText.resend }}</span>
            </button>

            <a-button
              class="login-submit reset-submit"
              type="primary"
              :class="{ ready: canSubmitResetCode, 'is-loading': resetLoading }"
              :disabled="!canSubmitResetCode || resetLoading || resetSending"
              @click.stop="checkResetCode"
            >
              <span class="login-submit-label">
                {{ resetText.continue }}
                <span v-if="resetLoading" class="login-submit-spinner" aria-hidden="true"></span>
              </span>
            </a-button>

            <button class="reset-login-link" type="button" :disabled="resetBusy" @click.stop="returnToLogin">
              <span class="reset-login-prefix">{{ resetReturnLoginParts.prefix }}</span><span class="reset-login-action">{{ resetReturnLoginParts.action }}</span><span class="reset-login-prefix">{{ resetReturnLoginParts.suffix }}</span>
            </button>
          </div>

          <div v-if="resetStep == 'password'" class="reset-main reset-password">
            <h1>{{ resetText.passwordTitle }}</h1>
            <p v-if="resetText.passwordSubtitle" class="login-subtitle">{{ resetText.passwordSubtitle }}</p>

            <div class="clearable-field clearable-password-field reset-field" :class="{ 'password-field-focused': resetPasswordFocused }">
              <a-input-password
                v-model="resetForm.password"
                class="login-input password-input"
                :placeholder="resetText.passwordPlaceholder"
                :max-length="inputMaxLength"
                :disabled="resetLoading"
                @focus="resetPasswordFocused = true"
                @blur="resetPasswordFocused = false"
                @keyup.enter="submitResetPassword"
              />
              <button v-if="resetForm.password" class="input-clear" type="button" aria-label="Clear" :disabled="resetLoading" @click.stop="clearResetField('password')"></button>
            </div>

            <div class="clearable-field clearable-password-field reset-field" :class="{ 'password-field-focused': resetConfirmPasswordFocused }">
              <a-input-password
                v-model="resetForm.confirmPassword"
                class="login-input password-input"
                :placeholder="resetText.confirmPasswordPlaceholder"
                :max-length="inputMaxLength"
                :disabled="resetLoading"
                @focus="resetConfirmPasswordFocused = true"
                @blur="resetConfirmPasswordFocused = false"
                @keyup.enter="submitResetPassword"
              />
              <button v-if="resetForm.confirmPassword" class="input-clear" type="button" aria-label="Clear" :disabled="resetLoading" @click.stop="clearResetField('confirmPassword')"></button>
            </div>

            <a-button
              class="login-submit reset-submit"
              type="primary"
              :class="{ ready: canSubmitResetPassword, 'is-loading': resetLoading }"
              :disabled="!canSubmitResetPassword || resetLoading"
              @click.stop="submitResetPassword"
            >
              <span class="login-submit-label">
                {{ resetText.continue }}
                <span v-if="resetLoading" class="login-submit-spinner" aria-hidden="true"></span>
              </span>
            </a-button>

            <button class="reset-login-link" type="button" :disabled="resetLoading" @click.stop="returnToLogin">
              <span class="reset-login-prefix">{{ resetReturnLoginParts.prefix }}</span><span class="reset-login-action">{{ resetReturnLoginParts.action }}</span><span class="reset-login-prefix">{{ resetReturnLoginParts.suffix }}</span>
            </button>
          </div>
        </div>
      </section>

      <div v-if="sms_login == true && userInfo.areaCode == '+1'" class="sms-consent">
        <div class="consent-row" @click="is_read_privacy_go">
          <img v-if="is_read_privacy" src="@/assets/wap/r-select.png" alt="" />
          <img v-if="!is_read_privacy" src="@/assets/wap/r-unselect.png" alt="" />
          <span>Read and agree <a href="/privacy.html" target="_blank">Privacy policy</a></span>
        </div>

        <div class="consent-row" @click="is_agree_receive_go">
          <img v-if="is_agree_receive" src="@/assets/wap/r-select.png" alt="" />
          <img v-if="!is_agree_receive" src="@/assets/wap/r-unselect.png" alt="" />
          <span>I agree to receive text message</span>
        </div>

        <p>
          Message and data may rates apply. Enter your phone number to receive one time passcode message
          to your phone from Eartech. Msg may vary Reply "HELP" for help Reply "STOP" to cancel.
        </p>
      </div>
    </div>

    <a-modal
      v-model="resetSuccessVisible"
      width="360px"
      centered
      wrapClassName="reset-success-modal"
      :footer="null"
      :closable="false"
      :maskClosable="false"
    >
      <section class="reset-success-panel">
        <div class="reset-success-icon"></div>
        <h2>{{ resetText.success }}</h2>
        <p>{{ resetSuccessCountdownText }}</p>
      </section>
    </a-modal>
  </div>
</template>

<script>
// import  storage from 'store'
import {
  refreshLogin,
  login,
  getAreaCode,
  getCode,
  sendSmsCode,
  sendEmailCode,
  checkCode as checkCodeApi,
  resetPassword as resetPasswordApi
} from '@/api/api'
import { setToken,removeToken,getToken,getLanguage,setLanguage} from '@/api/auth'
import {loginLanguage} from "@/utils/language/login"
import { getPhoneValidationMessage } from '@/utils/phone'

const captchaVault = new WeakMap()
const INPUT_MAX_LENGTH = 125

function getCaptchaState(vm) {
  if (!captchaVault.has(vm)) {
    captchaVault.set(vm, {
      verified: false,
      secret: '',
      nonce: '',
      traceHash: '',
      signature: '',
      startX: 0,
      startOffset: 0,
      startTime: 0,
      duration: 0,
      samples: [],
      issuedAt: 0,
    })
  }
  return captchaVault.get(vm)
}

function createCaptchaSecret() {
  const bytes = new Uint8Array(16)
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  return Array.from(bytes).map(item => item.toString(16).padStart(2, '0')).join('')
}

function hashText(input) {
  let hash = 2166136261
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i)
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24)
  }
  return (hash >>> 0).toString(16).padStart(8, '0')
}

function buildTraceHash(samples) {
  return hashText(samples.map((item, index) => {
    if (index === 0) {
      return '0:0'
    }
    const previous = samples[index - 1]
    return `${Math.round(item.x - previous.x)}:${Math.max(0, item.t - previous.t)}`
  }).join('|'))
}

function buildCaptchaSignature(state) {
  return hashText(`${state.secret}:${state.nonce}:${state.traceHash}:${state.duration}:${state.issuedAt}`)
}

const LANGUAGE_OPTIONS = [
  { id: 'zh', label: 'Chinese (\u7b80\u4f53\u4e2d\u6587)' },
  { id: 'tw', label: 'Chinese (\u7e41\u9ad4\u4e2d\u6587)' },
  { id: 'nl', label: 'Dutch (Nederlands)' },
  { id: 'uk', label: 'English (English UK)' },
  { id: 'us', label: 'English (English US)' },
  { id: 'fr', label: 'French (Français)' },
  { id: 'de', label: 'German (Deutsch)' },
  { id: 'it', label: 'Italian (Italiano)' },
  { id: 'ja', label: 'Japanese (\u65e5\u672c\u8a9e)' },
  { id: 'ko', label: 'Korean (\ud55c\uad6d\uc5b4)' },
  { id: 'pt', label: 'Portuguese (Português)' },
  { id: 'ru', label: 'Russian (\u0420\u0443\u0441\u0441\u043a\u0438\u0439)' },
  { id: 'es', label: 'Spanish (Español)' }
]

const LOGIN_TEXTS = {
  zh: {
    title: '\u767b\u5f55',
    emailSubtitle: '\u8bf7\u8f93\u5165\u60a8\u7684\u7535\u5b50\u90ae\u7bb1\u4ee5\u767b\u5f55',
    phoneSubtitle: '\u8bf7\u8f93\u5165\u60a8\u7684\u624b\u673a\u53f7\u7801\u4ee5\u767b\u5f55',
    emailPlaceholder: '\u8bf7\u8f93\u5165\u60a8\u7684\u90ae\u7bb1',
    phonePlaceholder: '\u8bf7\u8f93\u5165\u60a8\u7684\u624b\u673a\u53f7',
    passwordPlaceholder: '\u8bf7\u8f93\u5165\u5bc6\u7801',
    forgot: '\u5fd8\u8bb0\u5bc6\u7801',
    login: '\u767b\u5f55',
    orUse: '\u6216\u8005\u4f7f\u7528',
    phoneLogin: '\u624b\u673a\u53f7\u767b\u5f55',
    emailLogin: '\u90ae\u7bb1\u767b\u5f55',
    registerTip: '\u6ca1\u6709\u8d26\u53f7\uff1f\u8bf7\u5148\u5728 Viwoods \u8bbe\u5907\u4e0a\u6ce8\u518c',
    updatePasswordTip: '\u4fee\u6539\u5bc6\u7801\u6216\u6ce8\u518c\u8bf7\u5728 Viwoods \u8bbe\u5907\u4e0a\u64cd\u4f5c',
    returnLogin: '\u8fd4\u56de\u767b\u5f55',
    emailRequired: '\u8bf7\u8f93\u5165\u90ae\u7bb1',
    phoneRequired: '\u8bf7\u8f93\u5165\u624b\u673a\u53f7',
    passwordRequired: '\u8bf7\u8f93\u5165\u5bc6\u7801',
    networkError: '\u7f51\u7edc\u5f02\u5e38\uff0c\u8bf7\u68c0\u67e5\u7f51\u7edc\u6216\u670d\u52a1\u5668',
    requestFailed: '\u8bf7\u6c42\u5931\u8d25\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5'
  },
  tw: {
    title: '\u767b\u5165',
    emailSubtitle: '\u8acb\u8f38\u5165\u60a8\u7684\u96fb\u5b50\u4fe1\u7bb1\u4ee5\u767b\u5165',
    phoneSubtitle: '\u8acb\u8f38\u5165\u60a8\u7684\u624b\u6a5f\u865f\u78bc\u4ee5\u767b\u5165',
    emailPlaceholder: '\u8acb\u8f38\u5165\u60a8\u7684\u4fe1\u7bb1',
    phonePlaceholder: '\u8acb\u8f38\u5165\u60a8\u7684\u624b\u6a5f\u865f\u78bc',
    passwordPlaceholder: '\u8acb\u8f38\u5165\u5bc6\u78bc',
    forgot: '\u5fd8\u8a18\u5bc6\u78bc',
    login: '\u767b\u5165',
    orUse: '\u6216\u8005\u4f7f\u7528',
    phoneLogin: '\u624b\u6a5f\u865f\u78bc\u767b\u5165',
    emailLogin: '\u4fe1\u7bb1\u767b\u5165',
    registerTip: '\u6c92\u6709\u5e33\u865f\uff1f\u8acb\u5148\u5728 Viwoods \u88dd\u7f6e\u4e0a\u8a3b\u518a',
    updatePasswordTip: '\u4fee\u6539\u5bc6\u78bc\u6216\u8a3b\u518a\u8acb\u5728 Viwoods \u88dd\u7f6e\u4e0a\u64cd\u4f5c',
    returnLogin: '\u8fd4\u56de\u767b\u5165',
    emailRequired: '\u8acb\u8f38\u5165\u4fe1\u7bb1',
    phoneRequired: '\u8acb\u8f38\u5165\u624b\u6a5f\u865f\u78bc',
    passwordRequired: '\u8acb\u8f38\u5165\u5bc6\u78bc',
    networkError: '\u7db2\u7d61\u7570\u5e38\uff0c\u8acb\u6aa2\u67e5\u7db2\u7d61\u6216\u4f3a\u670d\u5668',
    requestFailed: '\u8acb\u6c42\u5931\u6557\uff0c\u8acb\u7a0d\u5f8c\u91cd\u8a66'
  },
  us: {
    title: 'Login',
    emailSubtitle: 'Please enter your email to login',
    phoneSubtitle: 'Please enter your phone number to login',
    emailPlaceholder: 'Please enter your email',
    phonePlaceholder: 'Please enter your phone number',
    passwordPlaceholder: 'Please enter your password',
    forgot: 'Forgot password',
    login: 'Login',
    orUse: 'or use',
    phoneLogin: 'Phone login',
    emailLogin: 'Email login',
    registerTip: 'No account? Please register on a Viwoods device first',
    updatePasswordTip: 'Update password or register on a Viwoods device',
    returnLogin: 'Back to login',
    emailRequired: 'Email is required',
    phoneRequired: 'Phone number is required',
    passwordRequired: 'Password is required',
    networkError: 'Network error. Please check your network or server.',
    requestFailed: 'Request failed. Please try again later.'
  },
  uk: {
    title: 'Login',
    emailSubtitle: 'Please enter your email to login',
    phoneSubtitle: 'Please enter your phone number to login',
    emailPlaceholder: 'Please enter your email',
    phonePlaceholder: 'Please enter your phone number',
    passwordPlaceholder: 'Please enter your password',
    forgot: 'Forgot password',
    login: 'Login',
    orUse: 'or use',
    phoneLogin: 'Phone login',
    emailLogin: 'Email login',
    registerTip: 'No account? Please register on a Viwoods device first',
    updatePasswordTip: 'Update password or register on a Viwoods device',
    returnLogin: 'Back to login',
    emailRequired: 'Email is required',
    phoneRequired: 'Phone number is required',
    passwordRequired: 'Password is required',
    networkError: 'Network error. Please check your network or server.',
    requestFailed: 'Request failed. Please try again later.'
  },
  nl: {
    title: 'Inloggen',
    emailSubtitle: 'Voer uw e-mailadres in om in te loggen',
    phoneSubtitle: 'Voer uw telefoonnummer in om in te loggen',
    emailPlaceholder: 'Voer uw e-mailadres in',
    phonePlaceholder: 'Voer uw telefoonnummer in',
    passwordPlaceholder: 'Voer uw wachtwoord in',
    forgot: 'Wachtwoord vergeten',
    login: 'Inloggen',
    orUse: 'of gebruik',
    phoneLogin: 'Inloggen met telefoon',
    emailLogin: 'Inloggen met e-mail',
    registerTip: 'Geen account? Registreer eerst op een Viwoods-apparaat',
    updatePasswordTip: 'Wijzig uw wachtwoord of registreer op een Viwoods-apparaat',
    returnLogin: 'Terug naar inloggen',
    emailRequired: 'E-mail is verplicht',
    phoneRequired: 'Telefoonnummer is verplicht',
    passwordRequired: 'Wachtwoord is verplicht',
    networkError: 'Netwerkfout. Controleer uw netwerk of server.',
    requestFailed: 'Verzoek mislukt. Probeer het later opnieuw.'
  },
  fr: {
    title: 'Connexion',
    emailSubtitle: 'Veuillez saisir votre e-mail pour vous connecter',
    phoneSubtitle: 'Veuillez saisir votre numéro de téléphone',
    emailPlaceholder: 'Veuillez saisir votre e-mail',
    phonePlaceholder: 'Veuillez saisir votre numéro de téléphone',
    passwordPlaceholder: 'Veuillez saisir votre mot de passe',
    forgot: 'Mot de passe oublié',
    login: 'Connexion',
    orUse: 'ou utiliser',
    phoneLogin: 'Connexion par telephone',
    emailLogin: 'Connexion par e-mail',
    registerTip: 'Pas de compte? Inscrivez-vous sur un appareil Viwoods',
    updatePasswordTip: 'Modifiez le mot de passe ou inscrivez-vous sur un appareil Viwoods',
    returnLogin: 'Retour à la connexion',
    emailRequired: 'E-mail requis',
    phoneRequired: 'Numero de telephone requis',
    passwordRequired: 'Mot de passe requis',
    networkError: 'Erreur reseau. Verifiez votre reseau ou le serveur.',
    requestFailed: 'La requete a echoue. Veuillez reessayer plus tard.'
  },
  de: {
    title: 'Anmelden',
    emailSubtitle: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    phoneSubtitle: 'Bitte geben Sie Ihre Telefonnummer ein',
    emailPlaceholder: 'Bitte E-Mail-Adresse eingeben',
    phonePlaceholder: 'Bitte Telefonnummer eingeben',
    passwordPlaceholder: 'Bitte Passwort eingeben',
    forgot: 'Passwort vergessen',
    login: 'Anmelden',
    orUse: 'oder verwenden',
    phoneLogin: 'Telefon-Anmeldung',
    emailLogin: 'E-Mail-Anmeldung',
    registerTip: 'Kein Konto? Bitte zuerst auf einem Viwoods-Gerät registrieren',
    updatePasswordTip: 'Passwort ändern oder auf einem Viwoods-Gerät registrieren',
    returnLogin: 'Zurück zur Anmeldung',
    emailRequired: 'E-Mail ist erforderlich',
    phoneRequired: 'Telefonnummer ist erforderlich',
    passwordRequired: 'Passwort ist erforderlich',
    networkError: 'Netzwerkfehler. Bitte pruefen Sie Ihr Netzwerk oder den Server.',
    requestFailed: 'Anfrage fehlgeschlagen. Bitte versuchen Sie es spaeter erneut.'
  },
  it: {
    title: 'Accedi',
    emailSubtitle: 'Inserisci la tua e-mail per accedere',
    phoneSubtitle: 'Inserisci il tuo numero di telefono',
    emailPlaceholder: 'Inserisci la tua e-mail',
    phonePlaceholder: 'Inserisci il tuo numero di telefono',
    passwordPlaceholder: 'Inserisci la password',
    forgot: 'Password dimenticata',
    login: 'Accedi',
    orUse: 'oppure usa',
    phoneLogin: 'Accesso con telefono',
    emailLogin: 'Accesso con e-mail',
    registerTip: 'Nessun account? Registrati prima su un dispositivo Viwoods',
    updatePasswordTip: 'Aggiorna la password o registrati su un dispositivo Viwoods',
    returnLogin: 'Torna al login',
    emailRequired: 'E-mail obbligatoria',
    phoneRequired: 'Numero di telefono obbligatorio',
    passwordRequired: 'Password obbligatoria',
    networkError: 'Errore di rete. Controlla la rete o il server.',
    requestFailed: 'Richiesta non riuscita. Riprova piu tardi.'
  },
  ja: {
    title: '\u30ed\u30b0\u30a4\u30f3',
    emailSubtitle: '\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b\u3057\u3066\u30ed\u30b0\u30a4\u30f3\u3057\u3066\u304f\u3060\u3055\u3044',
    phoneSubtitle: '\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b\u3057\u3066\u30ed\u30b0\u30a4\u30f3\u3057\u3066\u304f\u3060\u3055\u3044',
    emailPlaceholder: '\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b',
    phonePlaceholder: '\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b',
    passwordPlaceholder: '\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u5165\u529b',
    forgot: '\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u304a\u5fd8\u308c\u3067\u3059\u304b',
    login: '\u30ed\u30b0\u30a4\u30f3',
    orUse: '\u307e\u305f\u306f',
    phoneLogin: '\u96fb\u8a71\u756a\u53f7\u3067\u30ed\u30b0\u30a4\u30f3',
    emailLogin: '\u30e1\u30fc\u30eb\u3067\u30ed\u30b0\u30a4\u30f3',
    registerTip: '\u30a2\u30ab\u30a6\u30f3\u30c8\u304c\u3042\u308a\u307e\u305b\u3093\u304b? Viwoods \u30c7\u30d0\u30a4\u30b9\u3067\u767b\u9332\u3057\u3066\u304f\u3060\u3055\u3044',
    updatePasswordTip: '\u30d1\u30b9\u30ef\u30fc\u30c9\u5909\u66f4\u307e\u305f\u306f\u767b\u9332\u306f Viwoods \u30c7\u30d0\u30a4\u30b9\u3067\u884c\u3063\u3066\u304f\u3060\u3055\u3044',
    returnLogin: '\u30ed\u30b0\u30a4\u30f3\u306b\u623b\u308b',
    emailRequired: '\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u306f\u5fc5\u9808\u3067\u3059',
    phoneRequired: '\u96fb\u8a71\u756a\u53f7\u306f\u5fc5\u9808\u3067\u3059',
    passwordRequired: '\u30d1\u30b9\u30ef\u30fc\u30c9\u306f\u5fc5\u9808\u3067\u3059',
    networkError: '\u30cd\u30c3\u30c8\u30ef\u30fc\u30af\u30a8\u30e9\u30fc\u3067\u3059\u3002\u30cd\u30c3\u30c8\u30ef\u30fc\u30af\u307e\u305f\u306f\u30b5\u30fc\u30d0\u30fc\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002',
    requestFailed: '\u30ea\u30af\u30a8\u30b9\u30c8\u306b\u5931\u6557\u3057\u307e\u3057\u305f\u3002\u5f8c\u3067\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002'
  },
  ko: {
    title: '\ub85c\uadf8\uc778',
    emailSubtitle: '\uc774\uba54\uc77c\uc744 \uc785\ub825\ud558\uc5ec \ub85c\uadf8\uc778\ud558\uc138\uc694',
    phoneSubtitle: '\uc804\ud654\ubc88\ud638\ub97c \uc785\ub825\ud558\uc5ec \ub85c\uadf8\uc778\ud558\uc138\uc694',
    emailPlaceholder: '\uc774\uba54\uc77c \uc785\ub825',
    phonePlaceholder: '\uc804\ud654\ubc88\ud638 \uc785\ub825',
    passwordPlaceholder: '\ube44\ubc00\ubc88\ud638 \uc785\ub825',
    forgot: '\ube44\ubc00\ubc88\ud638\ub97c \uc78a\uc73c\uc168\ub098\uc694',
    login: '\ub85c\uadf8\uc778',
    orUse: '\ub610\ub294',
    phoneLogin: '\uc804\ud654\ubc88\ud638 \ub85c\uadf8\uc778',
    emailLogin: '\uc774\uba54\uc77c \ub85c\uadf8\uc778',
    registerTip: '\uacc4\uc815\uc774 \uc5c6\ub098\uc694? Viwoods \uae30\uae30\uc5d0\uc11c \uba3c\uc800 \ub4f1\ub85d\ud558\uc138\uc694',
    updatePasswordTip: '\ube44\ubc00\ubc88\ud638 \ubcc0\uacbd \ub610\ub294 \ub4f1\ub85d\uc740 Viwoods \uae30\uae30\uc5d0\uc11c \uc9c4\ud589\ud558\uc138\uc694',
    returnLogin: '\ub85c\uadf8\uc778\uc73c\ub85c \ub3cc\uc544\uac00\uae30',
    emailRequired: '\uc774\uba54\uc77c\uc740 \ud544\uc218\uc785\ub2c8\ub2e4',
    phoneRequired: '\uc804\ud654\ubc88\ud638\ub294 \ud544\uc218\uc785\ub2c8\ub2e4',
    passwordRequired: '\ube44\ubc00\ubc88\ud638\ub294 \ud544\uc218\uc785\ub2c8\ub2e4',
    networkError: '\ub124\ud2b8\uc6cc\ud06c \uc624\ub958\uc785\ub2c8\ub2e4. \ub124\ud2b8\uc6cc\ud06c \ub610\ub294 \uc11c\ubc84\ub97c \ud655\uc778\ud558\uc138\uc694.',
    requestFailed: '\uc694\uccad\uc774 \uc2e4\ud328\ud588\uc2b5\ub2c8\ub2e4. \ub098\uc911\uc5d0 \ub2e4\uc2dc \uc2dc\ub3c4\ud558\uc138\uc694.'
  },
  pt: {
    title: 'Entrar',
    emailSubtitle: 'Insira seu e-mail para entrar',
    phoneSubtitle: 'Insira seu número de telefone para entrar',
    emailPlaceholder: 'Insira seu e-mail',
    phonePlaceholder: 'Insira seu número de telefone',
    passwordPlaceholder: 'Insira sua senha',
    forgot: 'Esqueceu a senha',
    login: 'Entrar',
    orUse: 'ou use',
    phoneLogin: 'Entrar com telefone',
    emailLogin: 'Entrar com e-mail',
    registerTip: 'Sem conta? Registre-se primeiro em um dispositivo Viwoods',
    updatePasswordTip: 'Atualize a senha ou registre-se em um dispositivo Viwoods',
    returnLogin: 'Voltar ao login',
    emailRequired: 'E-mail obrigatorio',
    phoneRequired: 'Telefone obrigatorio',
    passwordRequired: 'Senha obrigatoria',
    networkError: 'Erro de rede. Verifique sua rede ou o servidor.',
    requestFailed: 'Falha na solicitacao. Tente novamente mais tarde.'
  },
  ru: {
    title: '\u0412\u043e\u0439\u0442\u0438',
    emailSubtitle: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 e-mail \u0434\u043b\u044f \u0432\u0445\u043e\u0434\u0430',
    phoneSubtitle: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430 \u0434\u043b\u044f \u0432\u0445\u043e\u0434\u0430',
    emailPlaceholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 e-mail',
    phonePlaceholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430',
    passwordPlaceholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c',
    forgot: '\u0417\u0430\u0431\u044b\u043b\u0438 \u043f\u0430\u0440\u043e\u043b\u044c',
    login: '\u0412\u043e\u0439\u0442\u0438',
    orUse: '\u0438\u043b\u0438',
    phoneLogin: '\u0412\u0445\u043e\u0434 \u043f\u043e \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0443',
    emailLogin: '\u0412\u0445\u043e\u0434 \u043f\u043e e-mail',
    registerTip: '\u041d\u0435\u0442 \u0430\u043a\u043a\u0430\u0443\u043d\u0442\u0430? \u0421\u043d\u0430\u0447\u0430\u043b\u0430 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044c \u043d\u0430 \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u0435 Viwoods',
    updatePasswordTip: '\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c \u0438\u043b\u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044c \u043d\u0430 \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u0435 Viwoods',
    returnLogin: '\u0412\u0435\u0440\u043d\u0443\u0442\u044c\u0441\u044f \u043a\u043e \u0432\u0445\u043e\u0434\u0443',
    emailRequired: '\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044f e-mail',
    phoneRequired: '\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044f \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430',
    passwordRequired: '\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044f \u043f\u0430\u0440\u043e\u043b\u044c',
    networkError: '\u041e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0442\u0438. \u041f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u0441\u0435\u0442\u044c \u0438\u043b\u0438 \u0441\u0435\u0440\u0432\u0435\u0440.',
    requestFailed: '\u0417\u0430\u043f\u0440\u043e\u0441 \u043d\u0435 \u0443\u0434\u0430\u043b\u0441\u044f. \u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u0437\u0436\u0435.'
  },
  es: {
    title: 'Iniciar sesión',
    emailSubtitle: 'Introduce tu correo para iniciar sesión',
    phoneSubtitle: 'Introduce tu número de teléfono para iniciar sesión',
    emailPlaceholder: 'Introduce tu correo electrónico',
    phonePlaceholder: 'Introduce tu número de teléfono',
    passwordPlaceholder: 'Introduce tu contraseña',
    forgot: 'Olvidaste la contraseña',
    login: 'Iniciar sesión',
    orUse: 'o usa',
    phoneLogin: 'Inicio con telefono',
    emailLogin: 'Inicio con correo',
    registerTip: 'No tienes cuenta? Registrate primero en un dispositivo Viwoods',
    updatePasswordTip: 'Actualiza la contraseña o regístrate en un dispositivo Viwoods',
    returnLogin: 'Volver al inicio',
    emailRequired: 'Correo obligatorio',
    phoneRequired: 'Telefono obligatorio',
    passwordRequired: 'Contrasena obligatoria',
    networkError: 'Error de red. Comprueba la red o el servidor.',
    requestFailed: 'La solicitud fallo. Intentalo de nuevo mas tarde.'
  }
}

const RESET_PASSWORD_TEXTS = {
  zh: {
    title: '\u91cd\u7f6e\u5bc6\u7801',
    accountSubtitle: '\u8bf7\u8f93\u5165\u60a8\u7684\u624b\u673a\u53f7\uff0c\u6211\u4eec\u5c06\u5411\u60a8\u53d1\u9001\u91cd\u7f6e\u5bc6\u7801\u9a8c\u8bc1\u7801\u3002',
    emailAccountSubtitle: '\u8bf7\u8f93\u5165\u60a8\u7684\u90ae\u7bb1\uff0c\u6211\u4eec\u5c06\u5411\u60a8\u53d1\u9001\u91cd\u7f6e\u5bc6\u7801\u9a8c\u8bc1\u7801\u3002',
    codeTitle: '\u8f93\u5165\u9a8c\u8bc1\u7801',
    codeSubtitle: '\u5305\u542b 6 \u4f4d\u9a8c\u8bc1\u7801\u7684\u6d88\u606f\u5df2\u53d1\u9001\u81f3 %s',
    passwordTitle: '\u8f93\u5165\u65b0\u5bc6\u7801',
    passwordSubtitle: '',
    phonePlaceholder: '\u8bf7\u8f93\u5165\u624b\u673a\u53f7',
    emailPlaceholder: '\u8bf7\u8f93\u5165\u90ae\u7bb1',
    codePlaceholder: '\u8f93\u5165\u9a8c\u8bc1\u7801',
    passwordPlaceholder: '\u5bc6\u7801\u957f\u5ea6\u4e0d\u5c11\u4e8e 8 \u4e2a\u5b57\u7b26',
    confirmPasswordPlaceholder: '\u8bf7\u518d\u6b21\u8f93\u5165\u5bc6\u7801',
    phoneReset: '\u624b\u673a\u53f7\u91cd\u7f6e',
    emailReset: '\u90ae\u7bb1\u91cd\u7f6e',
    continue: '\u7ee7\u7eed',
    back: '\u8fd4\u56de',
    resend: '\u91cd\u65b0\u53d1\u9001\u9a8c\u8bc1\u7801',
    resendAfter: '\u540e\u91cd\u53d1',
    sending: '\u53d1\u9001\u4e2d',
    success: '\u5bc6\u7801\u91cd\u7f6e\u6210\u529f\uff0c\u8bf7\u91cd\u65b0\u767b\u5f55\u3002',
    codeRequired: '\u8bf7\u8f93\u5165 6 \u4f4d\u9a8c\u8bc1\u7801',
    passwordMin: '\u8bf7\u8f93\u5165\u4e0d\u5c11\u4e8e 8 \u4e2a\u5b57\u7b26\u7684\u5bc6\u7801',
    passwordMatch: '\u4e24\u6b21\u8f93\u5165\u7684\u5bc6\u7801\u4e0d\u4e00\u81f4',
    orUse: '\u6216\u8005\u4f7f\u7528',
    returnLogin: '\u8fd4\u56de \u767b\u5f55'
  },
  tw: {
    title: '\u91cd\u7f6e\u5bc6\u78bc',
    accountSubtitle: '\u8acb\u8f38\u5165\u60a8\u7684\u624b\u6a5f\u865f\u78bc\uff0c\u6211\u5011\u5c07\u5411\u60a8\u767c\u9001\u91cd\u7f6e\u5bc6\u78bc\u9a57\u8b49\u78bc\u3002',
    emailAccountSubtitle: '\u8acb\u8f38\u5165\u60a8\u7684\u4fe1\u7bb1\uff0c\u6211\u5011\u5c07\u5411\u60a8\u767c\u9001\u91cd\u7f6e\u5bc6\u78bc\u9a57\u8b49\u78bc\u3002',
    codeTitle: '\u8f38\u5165\u9a57\u8b49\u78bc',
    codeSubtitle: '\u5305\u542b 6 \u4f4d\u9a57\u8b49\u78bc\u7684\u8a0a\u606f\u5df2\u767c\u9001\u81f3 %s',
    passwordTitle: '\u8f38\u5165\u65b0\u5bc6\u78bc',
    passwordSubtitle: '',
    phonePlaceholder: '\u8acb\u8f38\u5165\u624b\u6a5f\u865f\u78bc',
    emailPlaceholder: '\u8acb\u8f38\u5165\u4fe1\u7bb1',
    codePlaceholder: '\u8f38\u5165\u9a57\u8b49\u78bc',
    passwordPlaceholder: '\u5bc6\u78bc\u9577\u5ea6\u4e0d\u5c11\u65bc 8 \u500b\u5b57\u5143',
    confirmPasswordPlaceholder: '\u8acb\u518d\u6b21\u8f38\u5165\u5bc6\u78bc',
    phoneReset: '\u624b\u6a5f\u865f\u78bc\u91cd\u7f6e',
    emailReset: '\u4fe1\u7bb1\u91cd\u7f6e',
    continue: '\u7e7c\u7e8c',
    back: '\u8fd4\u56de',
    resend: '\u91cd\u65b0\u767c\u9001\u9a57\u8b49\u78bc',
    resendAfter: '\u5f8c\u91cd\u767c',
    sending: '\u767c\u9001\u4e2d',
    success: '\u5bc6\u78bc\u91cd\u7f6e\u6210\u529f\uff0c\u8acb\u91cd\u65b0\u767b\u5165\u3002',
    codeRequired: '\u8acb\u8f38\u5165 6 \u4f4d\u9a57\u8b49\u78bc',
    passwordMin: '\u8acb\u8f38\u5165\u4e0d\u5c11\u65bc 8 \u500b\u5b57\u5143\u7684\u5bc6\u78bc',
    passwordMatch: '\u5169\u6b21\u8f38\u5165\u7684\u5bc6\u78bc\u4e0d\u4e00\u81f4',
    orUse: '\u6216\u8005\u4f7f\u7528',
    returnLogin: '\u8fd4\u56de \u767b\u5165'
  },
  us: {
    title: 'Reset Password',
    accountSubtitle: 'Please enter your phone number. We will send a verification code.',
    emailAccountSubtitle: 'Please enter your email. We will send a verification code.',
    codeTitle: 'Enter Verification Code',
    codeSubtitle: 'A 6-digit verification code has been sent to %s',
    passwordTitle: 'Enter New Password',
    passwordSubtitle: '',
    phonePlaceholder: 'Please enter your phone number',
    emailPlaceholder: 'Please enter your email',
    codePlaceholder: 'Enter verification code',
    passwordPlaceholder: 'Password must be at least 8 characters',
    confirmPasswordPlaceholder: 'Please enter the password again',
    phoneReset: 'Phone reset',
    emailReset: 'Email reset',
    continue: 'Continue',
    back: 'Back',
    resend: 'Resend verification code',
    resendAfter: 'to resend',
    sending: 'Sending',
    success: 'Password reset successfully. Please log in again.',
    codeRequired: 'Please enter the 6-digit verification code',
    passwordMin: 'Please enter a password of at least 8 characters',
    passwordMatch: 'The two passwords do not match',
    orUse: 'or use',
    returnLogin: 'Back to login'
  },
  uk: {
    title: 'Reset Password',
    accountSubtitle: 'Please enter your phone number. We will send a verification code.',
    emailAccountSubtitle: 'Please enter your email. We will send a verification code.',
    codeTitle: 'Enter Verification Code',
    codeSubtitle: 'A 6-digit verification code has been sent to %s',
    passwordTitle: 'Enter New Password',
    passwordSubtitle: '',
    phonePlaceholder: 'Please enter your phone number',
    emailPlaceholder: 'Please enter your email',
    codePlaceholder: 'Enter verification code',
    passwordPlaceholder: 'Password must be at least 8 characters',
    confirmPasswordPlaceholder: 'Please enter the password again',
    phoneReset: 'Phone reset',
    emailReset: 'Email reset',
    continue: 'Continue',
    back: 'Back',
    resend: 'Resend verification code',
    resendAfter: 'to resend',
    sending: 'Sending',
    success: 'Password reset successfully. Please log in again.',
    codeRequired: 'Please enter the 6-digit verification code',
    passwordMin: 'Please enter a password of at least 8 characters',
    passwordMatch: 'The two passwords do not match',
    orUse: 'or use',
    returnLogin: 'Back to login'
  },
  nl: {
    title: 'Wachtwoord resetten',
    accountSubtitle: 'Voer uw telefoonnummer in. Wij sturen een verificatiecode.',
    emailAccountSubtitle: 'Voer uw e-mailadres in. Wij sturen een verificatiecode.',
    codeTitle: 'Verificatiecode invoeren',
    codeSubtitle: 'Er is een 6-cijferige verificatiecode verzonden naar %s',
    passwordTitle: 'Nieuw wachtwoord invoeren',
    passwordSubtitle: '',
    phonePlaceholder: 'Voer uw telefoonnummer in',
    emailPlaceholder: 'Voer uw e-mailadres in',
    codePlaceholder: 'Voer verificatiecode in',
    passwordPlaceholder: 'Wachtwoord minimaal 8 tekens',
    confirmPasswordPlaceholder: 'Voer het wachtwoord opnieuw in',
    phoneReset: 'Reset via telefoon',
    emailReset: 'Reset via e-mail',
    continue: 'Doorgaan',
    back: 'Terug',
    resend: 'Code opnieuw verzenden',
    resendAfter: 'opnieuw verzenden',
    sending: 'Verzenden',
    success: 'Wachtwoord gereset. Log opnieuw in.',
    codeRequired: 'Voer de 6-cijferige verificatiecode in',
    passwordMin: 'Voer een wachtwoord van minimaal 8 tekens in',
    passwordMatch: 'De twee wachtwoorden komen niet overeen',
    orUse: 'of gebruik',
    returnLogin: 'Terug naar inloggen'
  },
  fr: {
    title: 'Réinitialiser le mot de passe',
    accountSubtitle: 'Saisissez votre numéro de téléphone. Nous enverrons un code.',
    emailAccountSubtitle: 'Saisissez votre e-mail. Nous enverrons un code.',
    codeTitle: 'Saisir le code',
    codeSubtitle: 'Un code de vérification à 6 chiffres a été envoyé à %s',
    passwordTitle: 'Saisir un nouveau mot de passe',
    passwordSubtitle: '',
    phonePlaceholder: 'Saisissez votre numéro',
    emailPlaceholder: 'Saisissez votre e-mail',
    codePlaceholder: 'Saisir le code',
    passwordPlaceholder: 'Au moins 8 caractères',
    confirmPasswordPlaceholder: 'Saisissez encore le mot de passe',
    phoneReset: 'Réinitialiser par téléphone',
    emailReset: 'Reinitialiser par e-mail',
    continue: 'Continuer',
    back: 'Retour',
    resend: 'Renvoyer le code',
    resendAfter: 'pour renvoyer',
    sending: 'Envoi',
    success: 'Mot de passe réinitialisé. Connectez-vous à nouveau.',
    codeRequired: 'Saisissez le code de vérification à 6 chiffres',
    passwordMin: 'Saisissez un mot de passe d’au moins 8 caractères',
    passwordMatch: 'Les deux mots de passe ne correspondent pas',
    orUse: 'ou utiliser',
    returnLogin: 'Retour à la connexion'
  },
  de: {
    title: 'Passwort zurücksetzen',
    accountSubtitle: 'Geben Sie Ihre Telefonnummer ein. Wir senden einen Code.',
    emailAccountSubtitle: 'Geben Sie Ihre E-Mail ein. Wir senden einen Code.',
    codeTitle: 'Code eingeben',
    codeSubtitle: 'Ein 6-stelliger Code wurde an %s gesendet',
    passwordTitle: 'Neues Passwort eingeben',
    passwordSubtitle: '',
    phonePlaceholder: 'Telefonnummer eingeben',
    emailPlaceholder: 'E-Mail eingeben',
    codePlaceholder: 'Code eingeben',
    passwordPlaceholder: 'Passwort mindestens 8 Zeichen',
    confirmPasswordPlaceholder: 'Passwort erneut eingeben',
    phoneReset: 'Per Telefon zurücksetzen',
    emailReset: 'Per E-Mail zurücksetzen',
    continue: 'Weiter',
    back: 'Zurück',
    resend: 'Code erneut senden',
    resendAfter: 'bis erneut senden',
    sending: 'Senden',
    success: 'Passwort zurückgesetzt. Bitte erneut anmelden.',
    codeRequired: 'Bitte 6-stelligen Code eingeben',
    passwordMin: 'Bitte mindestens 8 Zeichen eingeben',
    passwordMatch: 'Die Passwörter stimmen nicht überein',
    orUse: 'oder verwenden',
    returnLogin: 'Zurück zur Anmeldung'
  },
  it: {
    title: 'Reimposta password',
    accountSubtitle: 'Inserisci il numero di telefono. Invieremo un codice.',
    emailAccountSubtitle: 'Inserisci la tua e-mail. Invieremo un codice.',
    codeTitle: 'Inserisci codice',
    codeSubtitle: 'Un codice di 6 cifre e stato inviato a %s',
    passwordTitle: 'Inserisci nuova password',
    passwordSubtitle: '',
    phonePlaceholder: 'Inserisci il telefono',
    emailPlaceholder: 'Inserisci la tua e-mail',
    codePlaceholder: 'Inserisci codice',
    passwordPlaceholder: 'Password di almeno 8 caratteri',
    confirmPasswordPlaceholder: 'Inserisci di nuovo la password',
    phoneReset: 'Reset telefono',
    emailReset: 'Reset e-mail',
    continue: 'Continua',
    back: 'Indietro',
    resend: 'Reinvia codice',
    resendAfter: 'per reinviare',
    sending: 'Invio',
    success: 'Password reimpostata. Accedi di nuovo.',
    codeRequired: 'Inserisci il codice di 6 cifre',
    passwordMin: 'Inserisci una password di almeno 8 caratteri',
    passwordMatch: 'Le password non corrispondono',
    orUse: 'oppure usa',
    returnLogin: 'Torna al login'
  },
  ja: {
    title: '\u30d1\u30b9\u30ef\u30fc\u30c9\u518d\u8a2d\u5b9a',
    accountSubtitle: '\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002\u8a8d\u8a3c\u30b3\u30fc\u30c9\u3092\u9001\u4fe1\u3057\u307e\u3059\u3002',
    emailAccountSubtitle: '\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002\u8a8d\u8a3c\u30b3\u30fc\u30c9\u3092\u9001\u4fe1\u3057\u307e\u3059\u3002',
    codeTitle: '\u8a8d\u8a3c\u30b3\u30fc\u30c9\u3092\u5165\u529b',
    codeSubtitle: '6\u6841\u306e\u8a8d\u8a3c\u30b3\u30fc\u30c9\u3092 %s \u306b\u9001\u4fe1\u3057\u307e\u3057\u305f',
    passwordTitle: '\u65b0\u3057\u3044\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u5165\u529b',
    passwordSubtitle: '',
    phonePlaceholder: '\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b',
    emailPlaceholder: '\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u3092\u5165\u529b',
    codePlaceholder: '\u8a8d\u8a3c\u30b3\u30fc\u30c9\u3092\u5165\u529b',
    passwordPlaceholder: '8\u6587\u5b57\u4ee5\u4e0a\u306e\u30d1\u30b9\u30ef\u30fc\u30c9',
    confirmPasswordPlaceholder: '\u3082\u3046\u4e00\u5ea6\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u5165\u529b',
    phoneReset: '\u96fb\u8a71\u756a\u53f7\u3067\u518d\u8a2d\u5b9a',
    emailReset: '\u30e1\u30fc\u30eb\u3067\u518d\u8a2d\u5b9a',
    continue: '\u7d9a\u3051\u308b',
    back: '\u623b\u308b',
    resend: '\u8a8d\u8a3c\u30b3\u30fc\u30c9\u3092\u518d\u9001\u4fe1',
    resendAfter: '\u5f8c\u306b\u518d\u9001\u4fe1',
    sending: '\u9001\u4fe1\u4e2d',
    success: '\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u518d\u8a2d\u5b9a\u3057\u307e\u3057\u305f\u3002\u518d\u5ea6\u30ed\u30b0\u30a4\u30f3\u3057\u3066\u304f\u3060\u3055\u3044\u3002',
    codeRequired: '6\u6841\u306e\u8a8d\u8a3c\u30b3\u30fc\u30c9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044',
    passwordMin: '8\u6587\u5b57\u4ee5\u4e0a\u306e\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044',
    passwordMatch: '\u30d1\u30b9\u30ef\u30fc\u30c9\u304c\u4e00\u81f4\u3057\u307e\u305b\u3093',
    orUse: '\u307e\u305f\u306f',
    returnLogin: '\u30ed\u30b0\u30a4\u30f3\u306b\u623b\u308b'
  },
  ko: {
    title: '\ube44\ubc00\ubc88\ud638 \uc7ac\uc124\uc815',
    accountSubtitle: '\uc804\ud654\ubc88\ud638\ub97c \uc785\ub825\ud558\uba74 \uc778\uc99d \ucf54\ub4dc\ub97c \ubcf4\ub0b4\ub4dc\ub9bd\ub2c8\ub2e4.',
    emailAccountSubtitle: '\uc774\uba54\uc77c\uc744 \uc785\ub825\ud558\uba74 \uc778\uc99d \ucf54\ub4dc\ub97c \ubcf4\ub0b4\ub4dc\ub9bd\ub2c8\ub2e4.',
    codeTitle: '\uc778\uc99d \ucf54\ub4dc \uc785\ub825',
    codeSubtitle: '6\uc790\ub9ac \uc778\uc99d \ucf54\ub4dc\uac00 %s \ub85c \uc804\uc1a1\ub418\uc5c8\uc2b5\ub2c8\ub2e4',
    passwordTitle: '\uc0c8 \ube44\ubc00\ubc88\ud638 \uc785\ub825',
    passwordSubtitle: '',
    phonePlaceholder: '\uc804\ud654\ubc88\ud638 \uc785\ub825',
    emailPlaceholder: '\uc774\uba54\uc77c \uc785\ub825',
    codePlaceholder: '\uc778\uc99d \ucf54\ub4dc \uc785\ub825',
    passwordPlaceholder: '\ube44\ubc00\ubc88\ud638\ub294 8\uc790 \uc774\uc0c1',
    confirmPasswordPlaceholder: '\ube44\ubc00\ubc88\ud638\ub97c \ub2e4\uc2dc \uc785\ub825',
    phoneReset: '\uc804\ud654\ubc88\ud638\ub85c \uc7ac\uc124\uc815',
    emailReset: '\uc774\uba54\uc77c\ub85c \uc7ac\uc124\uc815',
    continue: '\uacc4\uc18d',
    back: '\ub4a4\ub85c',
    resend: '\uc778\uc99d \ucf54\ub4dc \uc7ac\uc804\uc1a1',
    resendAfter: '\ud6c4 \uc7ac\uc804\uc1a1',
    sending: '\uc804\uc1a1 \uc911',
    success: '\ube44\ubc00\ubc88\ud638\uac00 \uc7ac\uc124\uc815\ub418\uc5c8\uc2b5\ub2c8\ub2e4. \ub2e4\uc2dc \ub85c\uadf8\uc778\ud558\uc138\uc694.',
    codeRequired: '6\uc790\ub9ac \uc778\uc99d \ucf54\ub4dc\ub97c \uc785\ub825\ud558\uc138\uc694',
    passwordMin: '8\uc790 \uc774\uc0c1\uc758 \ube44\ubc00\ubc88\ud638\ub97c \uc785\ub825\ud558\uc138\uc694',
    passwordMatch: '\ub450 \ube44\ubc00\ubc88\ud638\uac00 \uc77c\uce58\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4',
    orUse: '\ub610\ub294',
    returnLogin: '\ub85c\uadf8\uc778\uc73c\ub85c \ub3cc\uc544\uac00\uae30'
  },
  pt: {
    title: 'Redefinir senha',
    accountSubtitle: 'Insira seu telefone. Enviaremos um código.',
    emailAccountSubtitle: 'Insira seu e-mail. Enviaremos um código.',
    codeTitle: 'Inserir código',
    codeSubtitle: 'Um código de 6 dígitos foi enviado para %s',
    passwordTitle: 'Inserir nova senha',
    passwordSubtitle: '',
    phonePlaceholder: 'Insira seu telefone',
    emailPlaceholder: 'Insira seu e-mail',
    codePlaceholder: 'Inserir código',
    passwordPlaceholder: 'Senha com no mínimo 8 caracteres',
    confirmPasswordPlaceholder: 'Insira a senha novamente',
    phoneReset: 'Redefinir por telefone',
    emailReset: 'Redefinir por e-mail',
    continue: 'Continuar',
    back: 'Voltar',
    resend: 'Reenviar código',
    resendAfter: 'para reenviar',
    sending: 'Enviando',
    success: 'Senha redefinida. Faça login novamente.',
    codeRequired: 'Insira o código de 6 dígitos',
    passwordMin: 'Insira uma senha com no mínimo 8 caracteres',
    passwordMatch: 'As senhas não coincidem',
    orUse: 'ou use',
    returnLogin: 'Voltar ao login'
  },
  ru: {
    title: '\u0421\u0431\u0440\u043e\u0441 \u043f\u0430\u0440\u043e\u043b\u044f',
    accountSubtitle: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430. \u041c\u044b \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u043c \u043a\u043e\u0434 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f.',
    emailAccountSubtitle: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 e-mail. \u041c\u044b \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u043c \u043a\u043e\u0434 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f.',
    codeTitle: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043a\u043e\u0434',
    codeSubtitle: '6-\u0437\u043d\u0430\u0447\u043d\u044b\u0439 \u043a\u043e\u0434 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d \u043d\u0430 %s',
    passwordTitle: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u0432\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c',
    passwordSubtitle: '',
    phonePlaceholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430',
    emailPlaceholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 e-mail',
    codePlaceholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043a\u043e\u0434',
    passwordPlaceholder: '\u041f\u0430\u0440\u043e\u043b\u044c \u043d\u0435 \u043c\u0435\u043d\u0435\u0435 8 \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432',
    confirmPasswordPlaceholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c \u0435\u0449\u0435 \u0440\u0430\u0437',
    phoneReset: '\u0421\u0431\u0440\u043e\u0441 \u043f\u043e \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0443',
    emailReset: '\u0421\u0431\u0440\u043e\u0441 \u043f\u043e e-mail',
    continue: '\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c',
    back: '\u041d\u0430\u0437\u0430\u0434',
    resend: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043a\u043e\u0434 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e',
    resendAfter: '\u0434\u043e \u043f\u043e\u0432\u0442\u043e\u0440\u0430',
    sending: '\u041e\u0442\u043f\u0440\u0430\u0432\u043a\u0430',
    success: '\u041f\u0430\u0440\u043e\u043b\u044c \u0441\u0431\u0440\u043e\u0448\u0435\u043d. \u0412\u043e\u0439\u0434\u0438\u0442\u0435 \u0441\u043d\u043e\u0432\u0430.',
    codeRequired: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 6-\u0437\u043d\u0430\u0447\u043d\u044b\u0439 \u043a\u043e\u0434',
    passwordMin: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043f\u0430\u0440\u043e\u043b\u044c \u043d\u0435 \u043c\u0435\u043d\u0435\u0435 8 \u0441\u0438\u043c\u0432\u043e\u043b\u043e\u0432',
    passwordMatch: '\u041f\u0430\u0440\u043e\u043b\u0438 \u043d\u0435 \u0441\u043e\u0432\u043f\u0430\u0434\u0430\u044e\u0442',
    orUse: '\u0438\u043b\u0438',
    returnLogin: '\u0412\u0435\u0440\u043d\u0443\u0442\u044c\u0441\u044f \u043a\u043e \u0432\u0445\u043e\u0434\u0443'
  },
  es: {
    title: 'Restablecer contraseña',
    accountSubtitle: 'Introduce tu teléfono. Enviaremos un código.',
    emailAccountSubtitle: 'Introduce tu correo. Enviaremos un código.',
    codeTitle: 'Introduce código',
    codeSubtitle: 'Se envió un código de 6 dígitos a %s',
    passwordTitle: 'Introduce nueva contraseña',
    passwordSubtitle: '',
    phonePlaceholder: 'Introduce tu teléfono',
    emailPlaceholder: 'Introduce tu correo',
    codePlaceholder: 'Introduce código',
    passwordPlaceholder: 'Contraseña de al menos 8 caracteres',
    confirmPasswordPlaceholder: 'Introduce la contraseña otra vez',
    phoneReset: 'Restablecer por teléfono',
    emailReset: 'Restablecer por correo',
    continue: 'Continuar',
    back: 'Volver',
    resend: 'Reenviar código',
    resendAfter: 'para reenviar',
    sending: 'Enviando',
    success: 'Contraseña restablecida. Inicia sesión de nuevo.',
    codeRequired: 'Introduce el código de 6 dígitos',
    passwordMin: 'Introduce una contraseña de al menos 8 caracteres',
    passwordMatch: 'Las contraseñas no coinciden',
    orUse: 'o usa',
    returnLogin: 'Volver al inicio'
  }
}

const RESET_RETURN_LOGIN_ACTIONS = {
  zh: '\u767b\u5f55',
  tw: '\u767b\u5165',
  us: 'login',
  uk: 'login',
  nl: 'inloggen',
  fr: 'connexion',
  de: 'Anmeldung',
  it: 'login',
  ja: '\u30ed\u30b0\u30a4\u30f3',
  ko: '\ub85c\uadf8\uc778',
  pt: 'login',
  ru: '\u0432\u0445\u043e\u0434\u0443',
  es: 'inicio'
}

function getResetPasswordText(languageId) {
  return RESET_PASSWORD_TEXTS[languageId] || RESET_PASSWORD_TEXTS.us
}

function getReturnLoginParts(languageId, text) {
  const source = text || ''
  const action = RESET_RETURN_LOGIN_ACTIONS[languageId] || RESET_RETURN_LOGIN_ACTIONS.us
  const index = source.toLowerCase().lastIndexOf(action.toLowerCase())
  if (index < 0) {
    return {
      prefix: '',
      action: source,
      suffix: ''
    }
  }
  return {
    prefix: source.slice(0, index),
    action: source.slice(index, index + action.length),
    suffix: source.slice(index + action.length)
  }
}

const CAPTCHA_TEXTS = {
  zh: {
    slide: '\u5411\u53f3\u6ed1\u52a8\u5b8c\u6210\u9a8c\u8bc1',
    release: '\u677e\u5f00\u5b8c\u6210\u9a8c\u8bc1',
    verified: '\u9a8c\u8bc1\u901a\u8fc7',
    retry: '\u8bf7\u6309\u6b63\u5e38\u901f\u5ea6\u62d6\u52a8\u6ed1\u5757\u5b8c\u6210\u9a8c\u8bc1',
    complete: '\u8bf7\u5148\u5b8c\u6210\u6ed1\u5757\u9a8c\u8bc1'
  },
  tw: {
    slide: '\u5411\u53f3\u6ed1\u52d5\u5b8c\u6210\u9a57\u8b49',
    release: '\u653e\u958b\u5b8c\u6210\u9a57\u8b49',
    verified: '\u9a57\u8b49\u901a\u904e',
    retry: '\u8acb\u4ee5\u6b63\u5e38\u901f\u5ea6\u62d6\u52d5\u6ed1\u584a\u5b8c\u6210\u9a57\u8b49',
    complete: '\u8acb\u5148\u5b8c\u6210\u6ed1\u584a\u9a57\u8b49'
  },
  us: {
    slide: 'Slide right to verify',
    release: 'Release to verify',
    verified: 'Verified',
    retry: 'Please drag the slider at a normal speed',
    complete: 'Please complete the slider verification'
  },
  uk: {
    slide: 'Slide right to verify',
    release: 'Release to verify',
    verified: 'Verified',
    retry: 'Please drag the slider at a normal speed',
    complete: 'Please complete the slider verification'
  }
}

function getCaptchaText(languageId) {
  return CAPTCHA_TEXTS[languageId] || CAPTCHA_TEXTS.us
}

export default {
  data(){
    return {
      inputMaxLength: INPUT_MAX_LENGTH,
      userInfo:{
        username:"",
        email:"",
        phone:"",
        password:"",
        code:"",
        type:"",
        source:"",
        areaCode: '+86'
      },
      resetForm:{
        email:"",
        phone:"",
        areaCode:"+86",
        code:"",
        password:"",
        confirmPassword:""
      },
      areaCodes: [],

      loadingLogin:false,
      redirect:'/',
      type:1,
      update_pwd:0,
      resetMode:"phone",
      resetStep:"account",
      resetLoading:false,
      resetSending:false,
      resetReSendTime:0,
      resetTimer:null,
      resetSuccessVisible:false,
      resetSuccessCountdown:3,
      resetSuccessTimer:null,
      resetCheckedCode:"",
      resetPhoneFocused:false,
      loginPasswordFocused:false,
      resetPasswordFocused:false,
      resetConfirmPasswordFocused:false,
      resetAreaOptionsHeight:0,
      errMessage:0,
      languageName:'English (English US)',
      languageId:"us",
      languageList: LANGUAGE_OPTIONS,
      loginTexts: LOGIN_TEXTS,
      ll: loginLanguage,
      rules: {},
      start_choose:false,
      sms_login:false,
      is_send:0,
      phoneFocused:false,

      is_read_privacy:false,
      is_agree_receive:false,
      reSendTime: 0,
      captchaDragging:false,
      captchaOffset:0,
      captchaTrackWidth:338,
      captchaHandleWidth:42,
      captchaTick:0,
    }
  },
  computed: {
    currentText() {
      return this.loginTexts[this.languageId] || this.loginTexts.us
    },
    pageTitle() {
      return this.currentText.title
    },
    loginSubtitle() {
      return this.type == 1 ? this.currentText.emailSubtitle : this.currentText.phoneSubtitle
    },
    emailPlaceholder() {
      return this.currentText.emailPlaceholder
    },
    phonePlaceholder() {
      return this.currentText.phonePlaceholder
    },
    areaCodePlaceholder() {
      return 'Code'
    },
    verificationPlaceholder() {
      return this.resetText.codePlaceholder || 'Please enter the code'
    },
    passwordPlaceholder() {
      return this.currentText.passwordPlaceholder
    },
    forgotText() {
      return this.currentText.forgot
    },
    loginText() {
      return this.currentText.login
    },
    disabledLoginText() {
      return this.currentText.login
    },
    orText() {
      return this.currentText.orUse
    },
    switchLoginText() {
      return this.type == 1 ? this.currentText.phoneLogin : this.currentText.emailLogin
    },
    registerTip() {
      return this.currentText.registerTip
    },
    updatePasswordTip() {
      return this.currentText.updatePasswordTip
    },
    returnLoginText() {
      return this.currentText.returnLogin
    },
    resetText() {
      return getResetPasswordText(this.languageId)
    },
    resetAccountSubtitle() {
      return this.resetMode == 'phone' ? this.resetText.accountSubtitle : this.resetText.emailAccountSubtitle
    },
    resetOrText() {
      return this.resetText.orUse
    },
    resetReturnLoginText() {
      return this.resetText.returnLogin
    },
    resetReturnLoginParts() {
      return getReturnLoginParts(this.languageId, this.resetReturnLoginText)
    },
    resetAreaOptionsStyle() {
      if (!this.resetAreaOptionsHeight) {
        return {}
      }
      return {
        height: `${this.resetAreaOptionsHeight}px`,
        maxHeight: `${this.resetAreaOptionsHeight}px`
      }
    },
    resetCodeSubtitle() {
      const target = this.resetMode == 'phone'
        ? `${this.resetForm.areaCode} ${this.resetForm.phone}`
        : this.resetForm.email
      return this.resetText.codeSubtitle.replace('%s', target)
    },
    resetSuccessCountdownText() {
      if (this.languageId == 'zh') {
        return `${this.resetSuccessCountdown}s 后自动返回登录界面`
      }
      if (this.languageId == 'tw') {
        return `${this.resetSuccessCountdown}s 後自動返回登入頁`
      }
      return `Returning to login in ${this.resetSuccessCountdown}s`
    },
    captchaVerified() {
      this.captchaTick
      return getCaptchaState(this).verified
    },
    captchaMaxOffset() {
      return Math.max(0, this.captchaTrackWidth - this.captchaHandleWidth)
    },
    captchaFillWidth() {
      return this.captchaVerified ? this.captchaTrackWidth : this.captchaOffset + this.captchaHandleWidth
    },
    captchaText() {
      if (this.captchaVerified) {
        return this.captchaI18n.verified
      }
      if (this.captchaDragging) {
        return this.captchaI18n.release
      }
      return this.captchaI18n.slide
    },
    captchaI18n() {
      return getCaptchaText(this.languageId)
    },
    isCredentialReady() {
      if (this.type == 1) {
        return !!(this.userInfo.email && this.userInfo.password)
      }
      if (this.type == 2) {
        return !!(this.userInfo.areaCode && this.userInfo.phone && (this.sms_login ? this.userInfo.code : this.userInfo.password))
      }
      return false
    },
    canSubmitLogin() {
      return this.isCredentialReady && this.captchaVerified
    },
    resetBusy() {
      return this.resetSending || this.resetLoading
    },
    canSubmitResetAccount() {
      if (this.resetMode == 'phone') {
        return !!(this.resetForm.areaCode && this.resetForm.phone)
      }
      return !!this.resetForm.email
    },
    canSubmitResetPassword() {
      return !!(this.resetForm.password && this.resetForm.confirmPassword && this.resetForm.password.length >= 8 && this.resetForm.confirmPassword.length >= 8)
    },
    canSubmitResetCode() {
      return !!(this.resetForm.code && this.resetForm.code.length >= 6)
    }
  },
  mounted(){
    let ll = getLanguage()

    if(! (ll == "" || ll == undefined) && this.languageList.some(item => item.id == ll)) {
      this.languageId = ll
    }
    this.syncLanguageName()
    setLanguage(this.languageId)

    if (this.$route.query.redirect){
      this.redirect = this.$route.query.redirect
    }
    if (document.readyState === 'complete') {
      this.refreshLogins();
    } else {
      window.addEventListener('load', this.refreshLogins);
    }

    this.refreshRules()
  },
  beforeDestroy() {
    if (this.resetTimer) {
      clearInterval(this.resetTimer)
      this.resetTimer = null
    }
    this.stopResetSuccessCountdown()
    window.removeEventListener('load', this.refreshLogins);
    window.removeEventListener('mousemove', this.onCaptchaDrag);
    window.removeEventListener('mouseup', this.endCaptchaDrag);
    window.removeEventListener('touchmove', this.onCaptchaDrag);
    window.removeEventListener('touchend', this.endCaptchaDrag);
  },
  watch: {
    type(newValue) {
      if (this.$refs.loginFormModel) {
        this.$refs.loginFormModel.clearValidate(['email', 'phone']);
      }
      this.errMessage = '';
      if (newValue == '1') {
        this.userInfo.phone = ''
        this.sms_login = false
        this.refreshRules()
      } else if (newValue == '2') {
        this.userInfo.email = ''
        this.refreshRules()
      } else {
        this.rules.email = [];
        this.rules.phone = [];
      }
    }
  },

  methods: {
    refreshRules() {
      this.rules = {}
    },
    syncLanguageName() {
      const selectedLanguage = this.languageList.find(item => item.id == this.languageId)
      this.languageName = selectedLanguage ? selectedLanguage.label : 'English (English US)'
    },
    handleLanguage(event) {
      if (this.loadingLogin) {
        return
      }
      this.languageId = event.key
      this.syncLanguageName()
      setLanguage(this.languageId)
      this.clearErr()
      this.refreshRules()
      this.resetCaptcha()
    },
    switchLoginType() {
      if (this.loadingLogin) {
        return
      }
      this.type = this.type == 1 ? 2 : 1
      this.resetCaptcha()
    },
    getPointX(event) {
      if (event.touches && event.touches.length) {
        return event.touches[0].clientX
      }
      if (event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0].clientX
      }
      return event.clientX
    },
    startCaptchaDrag(event) {
      if (this.loadingLogin || this.captchaVerified) {
        return
      }
      const track = this.$refs.captchaTrack
      if (track && track.getBoundingClientRect) {
        this.captchaTrackWidth = track.getBoundingClientRect().width
      }
      const captchaState = getCaptchaState(this)
      captchaState.verified = false
      captchaState.secret = ''
      captchaState.nonce = ''
      captchaState.traceHash = ''
      captchaState.signature = ''
      captchaState.duration = 0
      this.captchaDragging = true
      captchaState.startX = this.getPointX(event)
      captchaState.startOffset = this.captchaOffset
      captchaState.startTime = Date.now()
      captchaState.samples = [{ x: captchaState.startX, t: captchaState.startTime }]
      this.captchaTick++
      window.addEventListener('mousemove', this.onCaptchaDrag)
      window.addEventListener('mouseup', this.endCaptchaDrag)
      window.addEventListener('touchmove', this.onCaptchaDrag, { passive: false })
      window.addEventListener('touchend', this.endCaptchaDrag)
    },
    onCaptchaDrag(event) {
      if (!this.captchaDragging) {
        return
      }
      if (event.cancelable) {
        event.preventDefault()
      }
      const captchaState = getCaptchaState(this)
      const pointX = this.getPointX(event)
      const nextOffset = captchaState.startOffset + pointX - captchaState.startX
      this.captchaOffset = Math.max(0, Math.min(this.captchaMaxOffset, nextOffset))
      captchaState.samples.push({ x: pointX, t: Date.now() })
      if (captchaState.samples.length > 80) {
        captchaState.samples.shift()
      }
    },
    endCaptchaDrag() {
      if (!this.captchaDragging) {
        return
      }
      this.captchaDragging = false
      window.removeEventListener('mousemove', this.onCaptchaDrag)
      window.removeEventListener('mouseup', this.endCaptchaDrag)
      window.removeEventListener('touchmove', this.onCaptchaDrag)
      window.removeEventListener('touchend', this.endCaptchaDrag)

      const captchaState = getCaptchaState(this)
      const duration = Date.now() - captchaState.startTime
      const distance = this.captchaOffset
      const reachedEnd = distance >= this.captchaMaxOffset - 3
      const hasEnoughSamples = captchaState.samples.length >= 10
      const hasHumanTiming = duration >= 650 && duration <= 8000
      const hasHumanMotion = this.hasHumanDragMotion()

      if (reachedEnd && hasEnoughSamples && hasHumanTiming && hasHumanMotion) {
        captchaState.verified = true
        captchaState.secret = createCaptchaSecret()
        captchaState.nonce = createCaptchaSecret()
        captchaState.duration = duration
        captchaState.traceHash = buildTraceHash(captchaState.samples)
        captchaState.issuedAt = Date.now()
        captchaState.signature = buildCaptchaSignature(captchaState)
        this.captchaOffset = this.captchaMaxOffset
        this.captchaTick++
        return
      }
      this.resetCaptcha()
      this.$message.error(this.captchaI18n.retry)
    },
    hasHumanDragMotion() {
      const captchaState = getCaptchaState(this)
      const samples = captchaState.samples
      if (samples.length < 10) {
        return false
      }
      let movingSteps = 0
      let maxStep = 0
      let minStep = Number.MAX_SAFE_INTEGER
      let directionChanges = 0
      let pauseCount = 0
      let speedChanges = 0
      let previousSpeed = null
      let previousDirection = 0
      let totalDistance = 0
      for (let i = 1; i < samples.length; i++) {
        const rawStep = samples[i].x - samples[i - 1].x
        const step = Math.abs(rawStep)
        const timeStep = Math.max(1, samples[i].t - samples[i - 1].t)
        const speed = step / timeStep
        totalDistance += step
        if (step > 0.5) {
          movingSteps++
        }
        if (step < 0.7) {
          pauseCount++
        }
        if (step > maxStep) {
          maxStep = step
        }
        if (step > 0 && step < minStep) {
          minStep = step
        }
        if (previousSpeed !== null && Math.abs(speed - previousSpeed) > 0.04) {
          speedChanges++
        }
        previousSpeed = speed
        const direction = rawStep > 0 ? 1 : (rawStep < 0 ? -1 : 0)
        if (direction !== 0 && previousDirection !== 0 && direction !== previousDirection) {
          directionChanges++
        }
        if (direction !== 0) {
          previousDirection = direction
        }
      }
      const averageSpeed = this.captchaOffset / Math.max(1, Date.now() - captchaState.startTime)
      const hasReasonableStep = maxStep < this.captchaTrackWidth * 0.38 && minStep < 8
      const hasEnoughMotion = movingSteps >= 8 && totalDistance >= this.captchaMaxOffset * 0.85
      const hasVariableSpeed = speedChanges >= 4
      const hasNaturalSpeed = averageSpeed >= 0.08 && averageSpeed <= 1.2
      const isNotPerfectlyStraightScript = directionChanges > 0 || pauseCount > 0 || speedChanges >= 7
      return hasEnoughMotion && hasReasonableStep && hasVariableSpeed && hasNaturalSpeed && isNotPerfectlyStraightScript
    },
    resetCaptcha() {
      const captchaState = getCaptchaState(this)
      captchaState.verified = false
      captchaState.secret = ''
      captchaState.nonce = ''
      captchaState.traceHash = ''
      captchaState.signature = ''
      captchaState.startX = 0
      captchaState.startOffset = 0
      captchaState.startTime = 0
      captchaState.duration = 0
      captchaState.samples = []
      captchaState.issuedAt = 0
      this.captchaDragging = false
      this.captchaOffset = 0
      this.captchaTick++
    },
    refreshLogins(){
      if (!getToken()) {
        this.loadingLogin = false
        this.getAreaCodes()
        return
      }
      refreshLogin({"uri":""}).then(ret => {
        if(ret.data.code == 200) {
          setToken(ret.data.data.token)
          setTimeout(() => {
            this.loadingLogin = false
            this.$router.push({ path: this.redirect })
          }, 500)
        } else {
          removeToken()
          this.getAreaCodes();
        }
      }).catch(error => {
        this.loadingLogin = false
        this.showLoginError(error)
        this.getAreaCodes()
      })
    },
    is_agree_receive_go(){
      this.is_agree_receive = !this.is_agree_receive
    },
    is_read_privacy_go(){
      this.is_read_privacy = !this.is_read_privacy
    },
    getCode() {
      if (this.loadingLogin) {
        return
      }
      if(this.reSendTime>0) {
        return;
      }
      if(!this.userInfo.areaCode) {
        return this.$message.error(this.areaCodePlaceholder)
      }
      if(!this.userInfo.phone) {
        return this.$message.error(this.currentText.phoneRequired)
      }
      const phoneValidationMessage = getPhoneValidationMessage(this.userInfo.areaCode, this.userInfo.phone, this.languageId)
      if (phoneValidationMessage) {
        return this.$message.error(phoneValidationMessage)
      }
      if(this.sms_login==true && this.userInfo.areaCode=='+1') {
        if(!this.is_read_privacy) {
          return this.$message.error("Please read and agree Privacy policy")
        }
        if(!this.is_agree_receive) {
          return this.$message.error("Please agree to receive text message")
        }
      }
      this.is_send = 1
      this.userInfo.type="1"
      getCode(this.userInfo).then(ret => {
        if(ret.data.code == 200) {
          this.is_send = 2
          this.reSendTime = ret.data.data.reSendTime || 121

          let timer = setInterval(() => {
            if (this.reSendTime <= 0) {
              clearInterval(timer);
            } else {
              this.reSendTime--;
            }
          }, 1000);
        } else {
          this.is_send = 0
          return this.$message.error(ret.data.msg)
        }
      }).catch(() => {
      })
    },
    change_start_choose(){
      if (this.loadingLogin || this.resetBusy) {
        return
      }
      this.start_choose = !this.start_choose
      if (this.start_choose && this.update_pwd == 1 && this.resetMode == 'phone') {
        this.updateResetAreaOptionsHeight()
      }
    },
    updateResetAreaOptionsHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.loginPanel
        const field = this.$refs.resetPhoneField
        if (!panel || !field || !panel.getBoundingClientRect || !field.getBoundingClientRect) {
          return
        }
        const panelRect = panel.getBoundingClientRect()
        const fieldRect = field.getBoundingClientRect()
        const dropdownTop = fieldRect.top + 44
        this.resetAreaOptionsHeight = Math.max(160, Math.floor(panelRect.bottom - dropdownTop))
      })
    },
    changeAreaCode(newVal) {
      if (this.loadingLogin) {
        return
      }
      this.userInfo.areaCode = newVal.areaCode;
      this.start_choose = false;
      this.clearErr();
      this.reSendTime = 0;
      this.is_send = 0;
    },
    clearErr(){
      this.errMessage = '';
      this.resetCaptcha()
    },
    clearUserField(field) {
      if (this.loadingLogin) {
        return
      }
      this.userInfo[field] = ''
      if(field == 'phone') {
        this.changePhone()
        return
      }
      this.clearErr()
    },
    changePhone(){
      this.errMessage = '';
      this.reSendTime = 0;
      this.is_send = 0;
      this.resetCaptcha()
    },
    stopResetCountdown() {
      if (this.resetTimer) {
        clearInterval(this.resetTimer)
        this.resetTimer = null
      }
    },
    clearResetField(field) {
      if (this.resetBusy) {
        return
      }
      this.resetForm[field] = ''
      if (field == 'phone' || field == 'email') {
        this.resetForm.code = ''
        this.resetCheckedCode = ''
        this.resetReSendTime = 0
        this.stopResetCountdown()
        return
      }
      if (field == 'code') {
        this.resetCheckedCode = ''
      }
    },
    getAreaCodes(){
      getAreaCode({}).then(ret => {
        if(ret.data.code == 200) {
          this.userInfo.code = ""
          this.areaCodes = ret.data.data
        }
      }).catch(error => {
        this.showLoginError(error)
      })
    },

    getApiErrorMessage(error) {
      const data = error && error.response && error.response.data ? error.response.data : (error && error.data ? error.data : {})
      if (error && error.code === 'ECONNABORTED') {
        return this.currentText.networkError || LOGIN_TEXTS.us.networkError
      }
      if (error && error.message && error.message.includes('Network Error')) {
        return this.currentText.networkError || LOGIN_TEXTS.us.networkError
      }
      return data.msg || data.message || (error && error.message) || this.currentText.requestFailed || LOGIN_TEXTS.us.requestFailed
    },
    showLoginError(error) {
      const messageText = typeof error == 'string' ? error : this.getApiErrorMessage(error)
      this.$message.destroy()
      this.$message.error(messageText)
    },

    getLoginValidationMessage() {
      if(this.type == 1) {
        if(!this.userInfo.email) {
          return this.currentText.emailRequired
        }
        if(!this.userInfo.password) {
          return this.currentText.passwordRequired
        }
      }
      if(this.type == 2) {
        if(!this.userInfo.areaCode) {
          return this.areaCodePlaceholder
        }
        if(!this.userInfo.phone) {
          return this.currentText.phoneRequired
        }
        const phoneValidationMessage = getPhoneValidationMessage(this.userInfo.areaCode, this.userInfo.phone, this.languageId)
        if (phoneValidationMessage) {
          return phoneValidationMessage
        }
        if(this.sms_login == true && !this.userInfo.code) {
          return this.verificationPlaceholder
        }
        if(this.sms_login == false && !this.userInfo.password) {
          return this.currentText.passwordRequired
        }
      }
      return ''
    },
    getCaptchaPayload() {
      const captchaState = getCaptchaState(this)
      const isFresh = captchaState.issuedAt && Date.now() - captchaState.issuedAt <= 5 * 60 * 1000
      const expectedSignature = buildCaptchaSignature(captchaState)
      if (!captchaState.verified || !captchaState.secret || !captchaState.nonce || !captchaState.signature || !isFresh) {
        return null
      }
      if (captchaState.signature !== expectedSignature) {
        return null
      }
      return {
        sliderVerifyKey: captchaState.secret,
        sliderVerifyNonce: captchaState.nonce,
        sliderVerifyTrace: captchaState.traceHash,
        sliderVerifyDuration: captchaState.duration,
        sliderVerifySig: captchaState.signature,
      }
    },
    openResetPassword() {
      if (this.loadingLogin) {
        return
      }
      this.update_pwd = 1
      this.start_choose = false
      this.resetStep = 'account'
      this.resetMode = this.type == 2 ? 'phone' : 'email'
      this.resetForm.email = this.userInfo.email || ''
      this.resetForm.phone = this.userInfo.phone || ''
      this.resetForm.areaCode = this.userInfo.areaCode || '+86'
      this.resetForm.code = ''
      this.resetForm.password = ''
      this.resetForm.confirmPassword = ''
      this.resetCheckedCode = ''
      this.resetReSendTime = 0
      this.resetSending = false
      if (this.resetTimer) {
        clearInterval(this.resetTimer)
        this.resetTimer = null
      }
      this.resetCaptcha()
    },
    returnToLogin() {
      if (this.resetBusy) {
        return
      }
      this.update_pwd = 0
      this.start_choose = false
      this.resetAreaOptionsHeight = 0
      this.resetStep = 'account'
      this.resetLoading = false
      this.resetSending = false
      this.resetCheckedCode = ''
      if (this.resetTimer) {
        clearInterval(this.resetTimer)
        this.resetTimer = null
      }
    },
    stopResetSuccessCountdown() {
      if (this.resetSuccessTimer) {
        clearInterval(this.resetSuccessTimer)
        this.resetSuccessTimer = null
      }
    },
    startResetSuccessCountdown() {
      this.stopResetSuccessCountdown()
      this.resetLoading = false
      this.resetSending = false
      this.resetSuccessVisible = true
      this.resetSuccessCountdown = 3
      this.resetSuccessTimer = setInterval(() => {
        if (this.resetSuccessCountdown <= 1) {
          this.stopResetSuccessCountdown()
          this.resetSuccessVisible = false
          this.completeResetPassword()
          return
        }
        this.resetSuccessCountdown--
      }, 1000)
    },
    completeResetPassword() {
      this.stopResetSuccessCountdown()
      this.resetSuccessVisible = false
      if (this.resetMode == 'phone') {
        this.type = 2
        this.userInfo.phone = this.resetForm.phone
        this.userInfo.areaCode = this.resetForm.areaCode || '+86'
        this.userInfo.email = ''
      } else {
        this.type = 1
        this.userInfo.email = this.resetForm.email
        this.userInfo.phone = ''
      }
      this.sms_login = false
      this.userInfo.password = ''
      this.userInfo.code = ''
      this.reSendTime = 0
      this.is_send = 0
      this.resetForm.code = ''
      this.resetForm.password = ''
      this.resetForm.confirmPassword = ''
      this.resetLoading = false
      this.resetSending = false
      this.returnToLogin()
      this.resetCaptcha()
    },
    resetGoBack() {
      if (this.resetBusy) {
        return
      }
      this.start_choose = false
      this.resetAreaOptionsHeight = 0
      if (this.resetStep == 'account') {
        this.returnToLogin()
        return
      }
      if (this.resetStep == 'password') {
        this.resetStep = 'code'
        this.resetForm.password = ''
        this.resetForm.confirmPassword = ''
        return
      }
      if (this.resetStep == 'code') {
        this.resetStep = 'account'
        this.resetForm.code = ''
        this.resetForm.password = ''
        this.resetForm.confirmPassword = ''
        this.resetCheckedCode = ''
        this.resetReSendTime = 0
        this.stopResetCountdown()
      }
    },
    switchResetMode(mode) {
      if (this.resetBusy) {
        return
      }
      this.resetMode = mode
      this.start_choose = false
      this.resetAreaOptionsHeight = 0
      this.resetForm.code = ''
      this.resetCheckedCode = ''
      this.resetReSendTime = 0
      if (this.resetTimer) {
        clearInterval(this.resetTimer)
        this.resetTimer = null
      }
    },
    changeResetAreaCode(newVal) {
      if (this.resetBusy) {
        return
      }
      this.resetForm.areaCode = newVal.areaCode
      this.start_choose = false
      this.resetReSendTime = 0
      if (this.resetTimer) {
        clearInterval(this.resetTimer)
        this.resetTimer = null
      }
    },
    getResetCodePayload() {
      const payload = { type: "7" }
      if (this.resetMode == 'phone') {
        payload.phone = this.resetForm.phone
        payload.areaCode = this.resetForm.areaCode
      } else {
        payload.email = this.resetForm.email
      }
      return payload
    },
    getResetPasswordPayload() {
      const payload = {
        password: this.resetForm.password,
        code: this.resetCheckedCode || this.resetForm.code
      }
      if (this.resetMode == 'phone') {
        payload.phone = this.resetForm.phone
        payload.areaCode = this.resetForm.areaCode
      } else {
        payload.email = this.resetForm.email
      }
      return payload
    },
    getResetValidationMessage() {
      if (this.resetMode == 'phone') {
        if (!this.resetForm.areaCode) {
          return this.areaCodePlaceholder
        }
        if (!this.resetForm.phone) {
          return this.resetText.phonePlaceholder
        }
        const phoneValidationMessage = getPhoneValidationMessage(this.resetForm.areaCode, this.resetForm.phone, this.languageId)
        if (phoneValidationMessage) {
          return phoneValidationMessage
        }
      } else if (!this.resetForm.email) {
        return this.resetText.emailPlaceholder
      }
      return ''
    },
    startResetCountdown(value) {
      if (this.resetTimer) {
        clearInterval(this.resetTimer)
      }
      this.resetReSendTime = Number(value) || 120
      this.resetTimer = setInterval(() => {
        if (this.resetReSendTime <= 0) {
          clearInterval(this.resetTimer)
          this.resetTimer = null
          return
        }
        this.resetReSendTime--
      }, 1000)
    },
    sendResetCode() {
      if (this.resetSending || this.resetLoading) {
        return
      }
      if (this.resetStep == 'code' && this.resetReSendTime > 0) {
        return
      }
      const validationMessage = this.getResetValidationMessage()
      if (validationMessage) {
        return this.$message.error(validationMessage)
      }
      const payload = this.getResetCodePayload()
      const requestApi = this.resetMode == 'phone' ? sendSmsCode : sendEmailCode
      this.resetSending = true
      requestApi(Object.assign({}, payload)).then(ret => {
        if(ret.data.code == 200) {
          this.resetStep = 'code'
          this.resetForm.code = ''
          this.resetCheckedCode = ''
          const reSendTime = ret.data.data && ret.data.data.reSendTime
          this.startResetCountdown(reSendTime || 120)
        } else {
          this.showLoginError(ret)
        }
      }).catch(error => {
        this.showLoginError(error)
      }).finally(() => {
        this.resetSending = false
      })
    },
    checkResetCode() {
      if (this.resetLoading || this.resetSending) {
        return
      }
      const validationMessage = this.getResetValidationMessage()
      if (validationMessage) {
        return this.$message.error(validationMessage)
      }
      if (!this.canSubmitResetCode) {
        return this.$message.error(this.resetText.codeRequired)
      }
      const payload = Object.assign({}, this.getResetCodePayload(), { code: this.resetForm.code })
      this.resetLoading = true
      checkCodeApi(payload).then(ret => {
        if(ret.data.code == 200) {
          this.resetCheckedCode = this.resetForm.code
          this.resetStep = 'password'
        } else {
          this.showLoginError(ret)
        }
      }).catch(error => {
        this.showLoginError(error)
      }).finally(() => {
        this.resetLoading = false
      })
    },
    submitResetPassword() {
      if (this.resetLoading || this.resetSending) {
        return
      }
      const validationMessage = this.getResetValidationMessage()
      if (validationMessage) {
        return this.$message.error(validationMessage)
      }
      if (!this.resetForm.password || this.resetForm.password.length < 8) {
        return this.$message.error(this.resetText.passwordMin)
      }
      if (this.resetForm.password != this.resetForm.confirmPassword) {
        return this.$message.error(this.resetText.passwordMatch)
      }
      const payload = this.getResetPasswordPayload()
      this.resetLoading = true
      resetPasswordApi(payload).then(ret => {
        if(ret.data.code == 200) {
          this.startResetSuccessCountdown()
        } else {
          this.showLoginError(ret)
        }
      }).catch(error => {
        this.showLoginError(error)
      }).finally(() => {
        this.resetLoading = false
      })
    },

    handleLogin(){
      if(this.loadingLogin) {
        return
      }
      const validationMessage = this.getLoginValidationMessage()
      if(validationMessage) {
        return this.$message.error(validationMessage)
      }
      if(!this.captchaVerified) {
        return this.$message.error(this.captchaI18n.complete)
      }
      const captchaPayload = this.getCaptchaPayload()
      if(!captchaPayload) {
        this.resetCaptcha()
        return this.$message.error(this.captchaI18n.complete)
      }
      if(this.userInfo.phone) {
        this.userInfo.email = ''
        if(!this.userInfo.areaCode) {
          return this.$message.error(this.areaCodePlaceholder)
        }
        if(this.userInfo.code) {
          this.userInfo.password=""
        }
        if(!this.userInfo.code && this.sms_login==true) {
          return this.$message.error(this.verificationPlaceholder)
        }
        if(!this.userInfo.password && this.sms_login==false) {
          return this.$message.error(this.currentText.passwordRequired)
        }
      }
      if(this.userInfo.email) {
        this.userInfo.phone = ''
      }
      this.userInfo.source = "2"
      const loginPayload = Object.assign({}, this.userInfo, captchaPayload)
      this.start_choose = false
      this.loadingLogin = true
      login(loginPayload).then(ret => {
        if(ret.data.code != 200) {
          this.showLoginError(ret.data.msg || ret.data.message || 'Login failed')
          this.resetCaptcha()
          this.loadingLogin = false
        }else {
          setToken(ret.data.data.token)
          setTimeout(() => {
            this.loadingLogin = false
            this.$router.push({ path: this.redirect })
          }, 500)
        }
      }).catch(error => {
        this.showLoginError(error)
        this.loadingLogin = false
      })
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

.ant-message {
  top: max(36px, calc((100vh - 650px) / 4)) !important;
  left: 50% !important;
  width: auto !important;
  padding: 0;
  transform: translate(-50%, -50%);
}

.ant-message-notice {
  padding: 0;
}

.ant-message-notice-content {
  border-radius: 0 !important;
}

.ant-message-success .anticon,
.ant-message-success .anticon-check-circle {
  color: #1F3A2D !important;
}

.reset-success-modal .ant-modal-content {
  border-radius: 0;
  box-shadow: 0 14px 36px rgba(23, 33, 29, .18);
}

.reset-success-modal .ant-modal-body {
  padding: 34px 34px 32px;
}

.reset-success-panel {
  text-align: center;
}

.reset-success-icon {
  width: 44px;
  height: 44px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: #1F3A2D;
  position: relative;
}

.reset-success-icon::after {
  content: "";
  position: absolute;
  left: 14px;
  top: 13px;
  width: 15px;
  height: 8px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
}

.reset-success-panel h2 {
  margin: 0;
  color: #1d2328;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.reset-success-panel p {
  margin: 10px 0 0;
  color: #59615e;
  font-size: 14px;
  line-height: 20px;
}
</style>

<style scoped>
.pc-login-page {
  width: 100vw;
  height: 100vh;
  background: #f8f4ef;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC, PingFang SC, Helvetica Neue, Arial, sans-serif;
  color: #1d2328;
  position: relative;
  overflow: hidden;
}

.login-language {
  position: absolute;
  top: 34px;
  right: 44px;
  z-index: 30;
}

.pc-login-page.is-submitting .language-trigger {
  pointer-events: none;
}

.language-trigger {
  height: 34px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #1d2328;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: pointer;
  user-select: none;
}

.language-icon {
  width: 17px;
  height: 17px;
  object-fit: contain;
}

.language-open {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.login-language-menu,
/deep/ .login-language-menu.ant-dropdown-menu {
  border-radius: 0;
  padding: 4px 0;
  overflow: hidden;
}

.login-language-menu /deep/ .ant-dropdown-menu-item,
/deep/ .login-language-menu .ant-dropdown-menu-item {
  min-width: 190px;
  height: 36px;
  line-height: 28px;
  color: #1d2328;
  font-size: 14px;
}

.login-language-menu /deep/ .ant-dropdown-menu-item:hover,
.login-language-menu /deep/ .ant-dropdown-menu-item-active,
.login-language-menu /deep/ .ant-dropdown-menu-item:focus,
/deep/ .login-language-menu .ant-dropdown-menu-item:hover,
/deep/ .login-language-menu .ant-dropdown-menu-item-active,
/deep/ .login-language-menu .ant-dropdown-menu-item:focus {
  background: #d6e2df;
}

.login-language-menu /deep/ .ant-dropdown-menu-item.selected,
/deep/ .login-language-menu .ant-dropdown-menu-item.selected {
  color: #275B52;
}

.login-frame {
  width: 488px;
  height: 650px;
  position: relative;
  transform-origin: center center;
}

.login-frame.reset-frame {
  width: 488px;
  height: 650px;
}

.login-panel {
  width: 488px;
  height: 650px;
  background: #fff;
  box-sizing: border-box;
  padding: 42px 75px 56px;
}

.login-panel.is-reset {
  width: 488px;
  height: 650px;
  padding: 42px 75px 56px;
}

.login-logo {
  display: flex;
  justify-content: center;
  height: 32px;
}

.login-logo img {
  width: 156px;
  height: auto;
  object-fit: contain;
  transform: translateY(-8px);
}

.login-main {
  margin-top: 28px;
  text-align: center;
}

.login-main h1 {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  line-height: 36px;
  color: #1d2328;
  letter-spacing: 0;
}

.login-subtitle {
  margin: 9px 0 31px;
  font-size: 15px;
  line-height: 22px;
  font-weight: 400;
  color: #38383d;
  letter-spacing: 0;
}

.login-form {
  text-align: left;
}

.login-form /deep/ .ant-form-item {
  margin-bottom: 24px;
}

.login-form /deep/ .ant-form-explain {
  min-height: 18px;
  margin-top: 4px;
  font-size: 12px;
  line-height: 18px;
}

.login-input,
.login-form /deep/ .login-input.ant-input,
.login-form /deep/ .password-input.ant-input-affix-wrapper {
  height: 44px;
  border-radius: 0;
  border: 1px solid #d9dfe3;
  background: #fff;
  color: #1d2328;
  font-size: 15px;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: 0;
  box-shadow: none;
}

.login-form /deep/ .login-input.ant-input {
  padding: 0 14px;
}

.login-form /deep/ .password-input.ant-input-affix-wrapper {
  padding: 0 40px 0 14px;
}

.login-form /deep/ .password-input .ant-input {
  height: 42px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1d2328;
  font-size: 15px;
  font-weight: 400;
  box-shadow: none;
}

.login-form /deep/ .login-input.ant-input:hover,
.login-form /deep/ .password-input.ant-input-affix-wrapper:hover {
  border-color: #d9dfe3;
  box-shadow: none;
}

.login-form /deep/ .login-input.ant-input:focus,
.login-form /deep/ .login-input.ant-input-focused,
.login-form /deep/ .password-input.ant-input-affix-wrapper-focused,
.login-form /deep/ .password-input.ant-input-affix-wrapper:focus,
.login-form /deep/ .password-input.ant-input-affix-wrapper:focus-within,
.login-form /deep/ .password-input.ant-input-affix-wrapper-focused:hover,
.login-form /deep/ .password-input.ant-input-affix-wrapper:hover:focus-within {
  border-color: #1f4032;
  box-shadow: 0 0 0 1px #1f4032;
}

.login-form /deep/ .password-input.ant-input-affix-wrapper-focused .ant-input,
.login-form /deep/ .password-input.ant-input-affix-wrapper-focused:hover .ant-input,
.login-form /deep/ .password-input.ant-input-affix-wrapper:focus-within .ant-input,
.login-form /deep/ .password-input.ant-input-affix-wrapper:hover:focus-within .ant-input,
.login-form /deep/ .password-input.ant-input-affix-wrapper:focus-within .ant-input:hover,
.login-form /deep/ .password-input.ant-input-affix-wrapper:focus-within .ant-input:focus {
  border: 0 !important;
  box-shadow: none !important;
  background: transparent;
}

.clearable-password-field.password-field-focused /deep/ .password-input.ant-input-affix-wrapper,
.clearable-password-field.password-field-focused /deep/ .password-input.ant-input-affix-wrapper:hover,
.reset-panel .clearable-password-field.password-field-focused /deep/ .password-input.ant-input-affix-wrapper,
.reset-panel .clearable-password-field.password-field-focused /deep/ .password-input.ant-input-affix-wrapper:hover {
  border-color: #1f4032 !important;
  box-shadow: 0 0 0 1px #1f4032 !important;
}

.clearable-password-field.password-field-focused /deep/ .password-input .ant-input,
.clearable-password-field.password-field-focused /deep/ .password-input:hover .ant-input,
.clearable-password-field.password-field-focused /deep/ .password-input .ant-input:hover,
.clearable-password-field.password-field-focused /deep/ .password-input .ant-input:focus,
.reset-panel .clearable-password-field.password-field-focused /deep/ .password-input .ant-input,
.reset-panel .clearable-password-field.password-field-focused /deep/ .password-input:hover .ant-input,
.reset-panel .clearable-password-field.password-field-focused /deep/ .password-input .ant-input:hover,
.reset-panel .clearable-password-field.password-field-focused /deep/ .password-input .ant-input:focus {
  border: 0 !important;
  box-shadow: none !important;
  background: transparent;
}

.login-form /deep/ .login-input.ant-input::placeholder,
.login-form /deep/ .password-input .ant-input::placeholder {
  color: #9aa19d;
  opacity: 1;
}

.login-form /deep/ .password-input .ant-input-suffix {
  right: 14px;
  color: #9b9f9d;
}

.login-form /deep/ .password-input .ant-input-password-icon,
.reset-panel /deep/ .password-input .ant-input-password-icon {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: -4px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.login-form /deep/ .password-input .ant-input-password-icon svg,
.reset-panel /deep/ .password-input .ant-input-password-icon svg {
  display: none;
}

.login-form /deep/ .password-input .ant-input-password-icon.anticon-eye,
.reset-panel /deep/ .password-input .ant-input-password-icon.anticon-eye {
  background-image: url("~@/assets/wap/common/password-eye.png");
}

.login-form /deep/ .password-input .ant-input-password-icon.anticon-eye-invisible,
.reset-panel /deep/ .password-input .ant-input-password-icon.anticon-eye-invisible {
  background-image: url("~@/assets/wap/common/password-eye-hidden.png");
}

.phone-field,
.code-field {
  display: flex;
  position: relative;
}

.area-code {
  width: auto;
  min-width: 68px;
  max-width: 112px;
  height: 44px;
  border: 1px solid #d9dfe3;
  border-right: 0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  color: #1d2328;
  font-size: 15px;
  font-weight: 400;
  box-sizing: border-box;
  transition: border-color .16s ease, box-shadow .16s ease;
}

.area-arrow {
  width: 8px;
  height: 8px;
  border-right: 1px solid #1d2328;
  border-bottom: 1px solid #1d2328;
  transform: rotate(45deg) translateY(-2px);
  flex-shrink: 0;
  transition: transform .16s ease;
}

.area-arrow.open {
  transform: rotate(225deg) translate(-2px, -2px);
}

.phone-input {
  flex: 1;
  min-width: 0;
}

.phone-field.focused {
  box-shadow: 0 0 0 1px #1f4032;
}

.phone-field.focused .area-code {
  border-color: #1f4032;
  border-right: 0;
  box-shadow: none;
  position: relative;
  z-index: 2;
}

.phone-field.focused /deep/ .phone-input.ant-input {
  border-color: #1f4032;
  border-left-color: #d9dfe3;
  box-shadow: none;
}

.area-options {
  position: absolute;
  top: 44px;
  left: 0;
  width: 338px;
  height: 406px;
  max-height: 406px;
  overflow-y: auto;
  z-index: 20;
  background: #fff;
  border: 1px solid #d9dfe3;
  box-sizing: border-box;
  box-shadow: 0 8px 18px rgba(0, 0, 0, .08);
}

.area-option {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
}

.area-option:hover {
  background: #F1EEE8;
}

.area-country {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.area-country img {
  width: 20px;
  height: 14px;
  object-fit: cover;
}

.area-country span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.send-code {
  width: 116px;
  height: 44px;
  border: 1px solid #1F3A2D;
  background: #1F3A2D;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
}

.form-meta {
  min-height: 20px;
  margin-top: -9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-button,
.sms-switch {
  border: 0;
  padding: 0;
  background: transparent;
  color: #1F3A2D;
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  cursor: pointer;
}

.text-button {
  margin-left: auto;
}

.human-check {
  margin-top: 12px;
  width: 100%;
}

.human-track {
  width: 100%;
  height: 42px;
  border: 1px solid #d9dfe3;
  background: #f6f8f7;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
}

.human-fill {
  height: 100%;
  width: 42px;
  background: rgba(31, 58, 45, .13);
  transition: width .18s ease;
}

.human-check.dragging .human-fill {
  transition: none;
}

.human-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a938e;
  font-size: 13px;
  line-height: 18px;
  pointer-events: none;
}

.human-handle {
  position: absolute;
  left: 0;
  top: 0;
  width: 42px;
  height: 40px;
  border: 0;
  border-right: 1px solid #d9dfe3;
  background: #fff;
  box-shadow: 0 2px 8px rgba(31, 58, 45, .12);
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform .18s ease, background .18s ease;
}

.human-check.dragging .human-handle {
  cursor: grabbing;
  transition: none;
}

.human-check.verified .human-fill {
  background: rgba(31, 58, 45, .18);
}

.human-check.verified .human-text {
  color: #1F3A2D;
}

.human-check.verified .human-handle {
  background: #1F3A2D;
  border-right-color: #1F3A2D;
  box-shadow: none;
  cursor: default;
}

.human-arrow {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a938e;
}

.human-arrow svg {
  width: 16px;
  height: 16px;
  display: block;
}

.human-arrow path {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}

.human-check-icon {
  width: 13px;
  height: 7px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg) translate(1px, -1px);
}

.submit-item {
  margin: 12px 0 0 !important;
}

.login-submit {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 0;
  border-color: #809086;
  background: #809086;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
  box-shadow: none;
  text-shadow: none;
}

.login-submit-label {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.login-submit-spinner {
  position: absolute;
  left: calc(100% + 9px);
  top: 50%;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, .45);
  border-top-color: #fff;
  border-radius: 50%;
  transform: translateY(-50%);
  animation: login-submit-spin .8s linear infinite;
  pointer-events: none;
}

@keyframes login-submit-spin {
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}

.login-submit:hover,
.login-submit:focus {
  border-color: #809086;
  background: #809086;
  color: #fff;
}

.login-submit.ready,
.login-submit.ready:hover,
.login-submit.ready:focus {
  border-color: #1F3A2D;
  background: #1F3A2D;
  color: #fff;
  opacity: 1;
}

.login-submit.is-loading,
.login-submit.is-loading:hover,
.login-submit.is-loading:focus,
.login-submit.is-loading[disabled],
.login-submit.is-loading[disabled]:hover,
.login-submit.is-loading[disabled]:focus,
.login-submit.is-loading[disabled]:active,
.login-submit[disabled],
.login-submit[disabled]:hover,
.login-submit[disabled]:focus,
.login-submit[disabled]:active {
  border-color: #809086;
  background: #809086;
  color: #fff;
  opacity: 1;
  cursor: not-allowed;
}

.login-main.is-submitting .login-input,
.login-main.is-submitting .area-code,
.login-main.is-submitting .input-clear,
.login-main.is-submitting .send-code,
.login-main.is-submitting .text-button,
.login-main.is-submitting .human-handle,
.login-main.is-submitting .switch-login {
  cursor: not-allowed;
}

.login-main.is-submitting .area-options {
  pointer-events: none;
}

.reset-panel.is-submitting .login-input,
.reset-panel.is-submitting .area-code,
.reset-panel.is-submitting .input-clear,
.reset-panel.is-submitting .reset-back,
.reset-panel.is-submitting .reset-resend,
.reset-panel.is-submitting .reset-switch,
.reset-panel.is-submitting .reset-login-link {
  cursor: not-allowed;
}

.reset-panel.is-submitting .area-options {
  pointer-events: none;
}

.reset-back[disabled],
.reset-resend[disabled],
.reset-switch[disabled],
.reset-login-link[disabled] {
  cursor: not-allowed;
}

.reset-back[disabled],
.reset-switch[disabled],
.reset-login-link[disabled] {
  opacity: .65;
}

.reset-resend[disabled] {
  color: #9aa19d;
}

.divider {
  margin: 22px 0 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #9b9f9d;
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  font-style: normal;
}

.divider span {
  flex: 1;
  height: 1px;
  background: #d9dfe3;
}

.divider em {
  font-style: normal;
  white-space: nowrap;
}

.switch-login {
  width: 176px;
  height: 34px;
  border: 1px solid #d9dfe3;
  border-radius: 4px;
  background: #fff;
  color: #1d2328;
  font-size: 14px;
  line-height: 32px;
  font-weight: 400;
  cursor: pointer;
  display: block;
  margin: 0 auto;
}

.sms-switch {
  display: block;
  margin: 12px auto 0;
  color: #1f4032;
}

.register-tip {
  margin: 32px 0 0;
  color: #9b9f9d;
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  text-align: center;
}

.reset-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
  position: relative;
}

.reset-back {
  position: absolute;
  top: -24px;
  left: -38px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #000;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.reset-back span {
  width: 18px;
  height: 18px;
  border: 0;
  position: relative;
  display: inline-block;
  flex: 0 0 18px;
  color: inherit;
}

.reset-back span::before {
  content: "";
  width: 10px;
  height: 10px;
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-35%, -50%) rotate(45deg);
}

.reset-main {
  padding-top: 86px;
  text-align: center;
}

.reset-main h1 {
  margin: 0;
  color: #1d2328;
  font-size: 24px;
  line-height: 34px;
  font-weight: 600;
  letter-spacing: 0;
}

.reset-main .login-subtitle {
  margin: 8px 0 0;
  min-height: 20px;
  color: #38383d;
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
  white-space: normal;
}

.reset-field {
  width: 100%;
  margin: 0;
}

.reset-main > .reset-field {
  margin-top: 32px;
}

.reset-panel /deep/ .login-input.ant-input {
  height: 44px;
  padding: 0 14px;
  border-radius: 0;
  color: #1d2328;
  font-size: 15px;
  line-height: 44px;
  box-shadow: none;
}

.reset-panel /deep/ .login-input.ant-input:focus,
.reset-panel /deep/ .login-input.ant-input-focused {
  border-color: #1f4032;
  box-shadow: 0 0 0 1px #1f4032;
}

.reset-panel .phone-field {
  height: 44px;
}

.reset-panel .phone-field.focused /deep/ .phone-input.ant-input,
.reset-panel .phone-field.focused /deep/ .phone-input.ant-input:focus,
.reset-panel .phone-field.focused /deep/ .phone-input.ant-input-focused {
  border-left-color: #d9dfe3;
  box-shadow: none;
}

.reset-panel .area-code {
  height: 44px;
  min-width: 68px;
  max-width: 112px;
  padding: 0 12px;
  gap: 8px;
  font-size: 14px;
}

.reset-panel .area-arrow {
  width: 7px;
  height: 7px;
}

.reset-panel .area-options {
  top: 44px;
  width: 338px;
  height: 360px;
  max-height: 360px;
}

.reset-panel /deep/ .password-input.ant-input-affix-wrapper {
  height: 44px;
  border-radius: 0;
  border: 1px solid #d9dfe3;
  background: #fff;
  color: #1d2328;
  font-size: 15px;
  box-shadow: none;
  padding: 0 40px 0 14px;
}

.reset-panel /deep/ .password-input .ant-input {
  height: 42px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1d2328;
  font-size: 15px;
  box-shadow: none;
}

.reset-panel /deep/ .password-input.ant-input-affix-wrapper-focused,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper:focus-within,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper-focused:hover,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper:hover:focus-within {
  border-color: #1f4032;
  box-shadow: 0 0 0 1px #1f4032;
}

.reset-panel /deep/ .password-input.ant-input-affix-wrapper-focused .ant-input,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper-focused:hover .ant-input,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper:focus-within .ant-input,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper:hover:focus-within .ant-input,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper:focus-within .ant-input:hover,
.reset-panel /deep/ .password-input.ant-input-affix-wrapper:focus-within .ant-input:focus {
  border: 0 !important;
  box-shadow: none !important;
  background: transparent;
}

.clearable-field {
  position: relative;
  width: 100%;
}

.code-input-field {
  flex: 1;
  min-width: 0;
}

.clearable-field /deep/ .login-input.ant-input,
.phone-field /deep/ .phone-input.ant-input {
  padding-right: 38px;
}

.clearable-password-field /deep/ .password-input.ant-input-affix-wrapper {
  width: 100%;
  padding-right: 68px;
}

.input-clear {
  position: absolute;
  top: 50%;
  right: 12px;
  width: 18px;
  height: 18px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  transform: translateY(-50%);
  z-index: 5;
}

.clearable-password-field .input-clear {
  right: 43px;
}

.input-clear::before,
.input-clear::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 8px;
  width: 10px;
  height: 1px;
  background: #9aa19d;
}

.input-clear::before {
  transform: rotate(45deg);
}

.input-clear::after {
  transform: rotate(-45deg);
}

.input-clear:hover::before,
.input-clear:hover::after {
  background: #1d2328;
}

.reset-submit {
  width: 100%;
  height: 45px;
  margin-top: 0;
  font-size: 15px;
  line-height: 1;
}

.reset-divider {
  margin: 24px 0 18px;
  gap: 12px;
  font-size: 13px;
  line-height: 19px;
}

.reset-switch {
  width: 176px;
  height: 34px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 32px;
}

.reset-account .reset-submit {
  margin-top: 70px;
}

.reset-code .reset-submit {
  margin-top: 58px;
}

.reset-password .reset-field {
  margin-top: 36px;
}

.reset-password .reset-field + .reset-field {
  margin-top: 16px;
}

.reset-password .reset-submit {
  margin-top: 38px;
}

.reset-resend {
  display: block;
  max-width: 180px;
  height: 18px;
  margin: 10px 0 0 auto;
  border: 0;
  padding: 0;
  background: transparent;
  color: #1f4032;
  font-size: 12px;
  line-height: 18px;
  text-decoration: underline;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.reset-login-link {
  position: absolute;
  left: 50%;
  bottom: 7px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #1F3A2D;
  font-size: 13px;
  line-height: 19px;
  cursor: pointer;
  display: block;
  transform: translateX(-50%);
  white-space: nowrap;
}

.reset-login-prefix {
  color: #1d2328;
}

.reset-login-action {
  color: #1F3A2D;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.sms-consent {
  position: absolute;
  top: 670px;
  left: 0;
  width: 488px;
  color: #1d2328;
  font-size: 12px;
  line-height: 18px;
}

.consent-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.consent-row img {
  width: 20px;
  height: 20px;
}

.sms-consent p {
  margin: 10px 0 0;
}

.wap-login-page {
  --wap-login-bg: #FAF4F0;
  --wap-login-green: #1F3B2B;
  --wap-login-text: #202321;
  --wap-login-muted: #858986;
  --wap-login-border: #DDDFDC;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  height: auto;
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--wap-login-bg);
  color: var(--wap-login-text);
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
}

.wap-login-page,
.wap-login-page * {
  box-sizing: border-box;
}

.wap-login-page button {
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

.wap-login-page .login-language {
  position: absolute;
  top: calc(env(safe-area-inset-top, 0px) + 50px);
  right: max(30px, calc((100vw - 460px) / 2 + 30px));
  z-index: 30;
}

.wap-login-page.is-reset .login-language {
  display: none;
}

.wap-login-page .language-trigger {
  height: 22px;
  gap: 6px;
  color: #90928F;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
}

.wap-login-page .language-icon {
  width: 16px;
  height: 16px;
}

.wap-login-page .language-open {
  display: none;
}

.wap-login-page .login-frame,
.wap-login-page .login-frame.reset-frame {
  width: min(100%, 460px);
  min-height: max(100vh, 720px);
  min-height: max(100dvh, 720px);
  height: auto;
  margin: 0 auto;
  transform: none !important;
  transform-origin: center top;
}

.wap-login-page .login-panel,
.wap-login-page .login-panel.is-reset {
  width: 100%;
  min-height: max(100vh, 720px);
  min-height: max(100dvh, 720px);
  height: auto;
  padding: 0 clamp(32px, 9.33vw, 43px);
  background: transparent;
}

.wap-login-page .login-logo {
  height: auto;
  padding-top: clamp(116px, 15.65vh, 132px);
  display: flex;
  justify-content: center;
}

.wap-login-page .login-logo img {
  width: 123.5px;
  height: 24px;
  object-fit: contain;
  transform: none;
}

.wap-login-page .login-main {
  margin-top: 28px;
  text-align: center;
}

.wap-login-page .login-main h1,
.wap-login-page .reset-main h1 {
  margin: 0;
  color: var(--wap-login-text);
  font-size: 24px;
  line-height: 33px;
  font-weight: 600;
  letter-spacing: 0;
}

.wap-login-page .login-subtitle {
  max-width: 100%;
  margin: 9px auto 32px;
  color: #3F423F;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  text-align: center;
}

.wap-login-page .login-form {
  text-align: left;
}

.wap-login-page .login-form /deep/ .ant-form-item {
  margin-bottom: 16px;
}

.wap-login-page .login-form /deep/ .ant-form-item-control,
.wap-login-page .login-form /deep/ .ant-form-item-children {
  line-height: normal;
}

.wap-login-page .login-form /deep/ .ant-form-explain {
  min-height: 0;
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
}

.wap-login-page .login-input,
.wap-login-page .login-form /deep/ .login-input.ant-input,
.wap-login-page .login-form /deep/ .password-input.ant-input-affix-wrapper,
.wap-login-page .reset-panel /deep/ .login-input.ant-input,
.wap-login-page .reset-panel /deep/ .password-input.ant-input-affix-wrapper {
  width: 100%;
  height: 44px;
  border: 1px solid var(--wap-login-border);
  border-radius: 0;
  background: #fff;
  color: var(--wap-login-text);
  font-size: 14px;
  line-height: 42px;
  font-weight: 400;
  box-shadow: none;
}

.wap-login-page .login-form /deep/ .login-input.ant-input,
.wap-login-page .reset-panel /deep/ .login-input.ant-input {
  padding: 0 46px 0 20px;
}

.wap-login-page .login-form /deep/ .password-input.ant-input-affix-wrapper,
.wap-login-page .reset-panel /deep/ .password-input.ant-input-affix-wrapper {
  padding: 0 44px 0 20px;
}

.wap-login-page .login-form /deep/ .password-input .ant-input,
.wap-login-page .reset-panel /deep/ .password-input .ant-input {
  height: 42px;
  padding: 0 32px 0 0;
  border: 0;
  background: transparent;
  color: var(--wap-login-text);
  font-size: 14px;
  line-height: 42px;
  box-shadow: none;
}

.wap-login-page .login-input::placeholder,
.wap-login-page .login-form /deep/ .login-input.ant-input::placeholder,
.wap-login-page .login-form /deep/ .password-input .ant-input::placeholder,
.wap-login-page .reset-panel /deep/ .login-input.ant-input::placeholder,
.wap-login-page .reset-panel /deep/ .password-input .ant-input::placeholder {
  color: #A3A6A3;
  opacity: 1;
}

.wap-login-page .login-form /deep/ .login-input.ant-input:focus,
.wap-login-page .login-form /deep/ .login-input.ant-input-focused,
.wap-login-page .login-form /deep/ .password-input.ant-input-affix-wrapper-focused,
.wap-login-page .login-form /deep/ .password-input.ant-input-affix-wrapper:focus-within,
.wap-login-page .reset-panel /deep/ .login-input.ant-input:focus,
.wap-login-page .reset-panel /deep/ .login-input.ant-input-focused,
.wap-login-page .reset-panel /deep/ .password-input.ant-input-affix-wrapper-focused,
.wap-login-page .reset-panel /deep/ .password-input.ant-input-affix-wrapper:focus-within {
  border-color: #AEB5B0;
  box-shadow: none;
}

.wap-login-page .login-form /deep/ .password-input .ant-input-password-icon,
.wap-login-page .reset-panel /deep/ .password-input .ant-input-password-icon {
  width: 29px;
  height: 28px;
  margin: 0;
  display: block;
  background: center / 29px 28px no-repeat;
  color: transparent;
  transform: translateX(3px);
}

.wap-login-page .login-form /deep/ .password-input .ant-input-password-icon svg,
.wap-login-page .reset-panel /deep/ .password-input .ant-input-password-icon svg {
  display: none;
}

.wap-login-page .login-form /deep/ .password-input .ant-input-password-icon.anticon-eye,
.wap-login-page .reset-panel /deep/ .password-input .ant-input-password-icon.anticon-eye {
  background-image: url("~@/assets/wap/login-password-show@2x.png");
}

.wap-login-page .login-form /deep/ .password-input .ant-input-password-icon.anticon-eye-invisible,
.wap-login-page .reset-panel /deep/ .password-input .ant-input-password-icon.anticon-eye-invisible {
  background-image: url("~@/assets/wap/login-password-hide@2x.png");
}

.wap-login-page .clearable-field,
.wap-login-page .phone-field,
.wap-login-page .code-field {
  width: 100%;
  min-height: 44px;
  position: relative;
}

.wap-login-page .input-clear {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 3;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent url("~@/assets/wap/login-close@2x.png") center / 24px 24px no-repeat;
  transform: translateY(-50%);
}

.wap-login-page .input-clear::before,
.wap-login-page .input-clear::after {
  display: none;
}

.wap-login-page .clearable-password-field > .input-clear {
  right: 45px;
  display: block;
}

.wap-login-page .phone-field {
  display: flex;
  border: 1px solid var(--wap-login-border);
  background: #fff;
}

.wap-login-page .phone-field .area-code {
  flex: 0 0 88px;
  width: 88px;
  height: 42px;
  border: 0;
  border-right: 1px solid var(--wap-login-border);
  padding: 0 12px;
  background: #fff;
  color: var(--wap-login-text);
  font-size: 14px;
}

.wap-login-page .phone-field /deep/ .phone-input.ant-input,
.wap-login-page .reset-panel .phone-field /deep/ .phone-input.ant-input {
  height: 42px;
  border: 0;
  padding-left: 14px;
}

.wap-login-page .area-options {
  top: 45px;
  left: 0;
  width: 100%;
  max-height: 230px;
  border-color: var(--wap-login-border);
  box-shadow: 0 8px 22px rgba(31, 59, 43, .12);
}

.wap-login-page .code-field {
  display: flex;
  gap: 12px;
}

.wap-login-page .code-input-field {
  min-width: 0;
  flex: 1 1 auto;
}

.wap-login-page .send-code {
  flex: 0 0 102px;
  width: 102px;
  height: 44px;
  border: 1px solid var(--wap-login-green);
  background: transparent;
  color: var(--wap-login-green);
  font-size: 13px;
}

.wap-login-page .form-meta {
  min-height: 20px;
  margin: -5px 0 28px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.wap-login-page .text-button {
  height: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--wap-login-green);
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
}

.wap-login-page .human-check {
  width: 100%;
  height: 44px;
  margin: 0;
}

.wap-login-page .human-track {
  width: 100%;
  height: 44px;
  border: 1px solid #C9D1CC;
  background: #F0F3F1;
}

.wap-login-page .human-fill {
  height: 42px;
  background: #F0F3F1;
}

.wap-login-page .human-text {
  color: #98A49D;
  font-size: 14px;
  line-height: 42px;
  text-align: center;
}

.wap-login-page .human-handle {
  top: -1px;
  left: -1px;
  width: 44px;
  height: 44px;
  border: 1px solid #AEB9B2;
  background: #fff;
}

.wap-login-page .human-arrow {
  width: 24px;
  height: 25px;
  display: block;
  background: url("~@/assets/wap/login-slider-arrow@2x.png") center / 24px 25px no-repeat;
}

.wap-login-page .human-arrow svg {
  display: none;
}

.wap-login-page .login-form /deep/ .submit-item.ant-form-item {
  margin: 16px 0 0;
}

.wap-login-page .login-submit,
.wap-login-page .reset-submit {
  width: 100%;
  height: 44px;
  margin: 0;
  border: 1px solid var(--wap-login-green);
  border-radius: 0;
  background: var(--wap-login-green);
  color: #fff;
  font-size: 16px;
  line-height: 42px;
  font-weight: 500;
  box-shadow: none;
  text-shadow: none;
}

.wap-login-page .login-submit.ready,
.wap-login-page .login-submit.ready:hover,
.wap-login-page .login-submit.ready:focus,
.wap-login-page .login-submit.ready:active,
.wap-login-page .reset-submit.ready,
.wap-login-page .reset-submit.ready:hover,
.wap-login-page .reset-submit.ready:focus,
.wap-login-page .reset-submit.ready:active {
  border-color: var(--wap-login-green);
  background: var(--wap-login-green);
  color: #fff;
}

.wap-login-page .login-submit[disabled],
.wap-login-page .login-submit[disabled]:hover,
.wap-login-page .login-submit[disabled]:focus,
.wap-login-page .login-submit[disabled]:active {
  border-color: #8D968F;
  background: #8D968F;
  color: #fff;
}

.wap-login-page .reset-submit[disabled],
.wap-login-page .reset-submit[disabled]:hover,
.wap-login-page .reset-submit[disabled]:focus,
.wap-login-page .reset-submit[disabled]:active {
  border-color: #8D968F;
  background: #8D968F;
  color: #fff;
}

.wap-login-page .divider {
  width: 100%;
  height: 20px;
  margin: 28px 0 20px;
  gap: 24px;
  color: #999D9A;
  font-size: 13px;
  line-height: 20px;
}

.wap-login-page .divider span {
  height: 1px;
  background: #DFE1DE;
}

.wap-login-page .divider em {
  color: #999D9A;
  font-style: normal;
  white-space: nowrap;
}

.wap-login-page .switch-login,
.wap-login-page .reset-switch {
  width: 176px;
  height: 34px;
  margin: 0 auto;
  display: block;
  border: 1px solid #DFDFDC;
  border-radius: 4px !important;
  background: transparent;
  color: #4A4D4A;
  font-size: 14px;
  line-height: 32px;
  font-weight: 400;
}

.wap-login-page .register-tip {
  position: absolute;
  left: 32px;
  right: 32px;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 13px);
  margin: 0;
  color: #858986;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  white-space: normal;
}

.wap-login-page .reset-panel {
  width: 100%;
  min-height: max(100vh, 720px);
  min-height: max(100dvh, 720px);
  height: auto;
  position: relative;
}

.wap-login-page .reset-back {
  position: absolute;
  top: calc(env(safe-area-inset-top, 0px) + 54px);
  left: calc(16px - clamp(32px, 9.33vw, 43px));
  z-index: 5;
  width: 36px;
  height: 36px;
  border: 1px solid #E4DBD4;
  border-radius: 50% !important;
  padding: 0;
  background: transparent url("~@/assets/wap/login-back@2x.png") center / 24px 24px no-repeat;
  color: transparent;
  font-size: 0;
}

.wap-login-page .reset-back span {
  display: none;
}

.wap-login-page .reset-main {
  width: 100%;
  min-height: max(100vh, 720px);
  min-height: max(100dvh, 720px);
  padding-top: clamp(170px, 22.4vh, 190px);
  position: relative;
  text-align: center;
}

.wap-login-page .reset-main .login-subtitle {
  margin-top: 9px;
  margin-bottom: 32px;
}

.wap-login-page .reset-account .login-subtitle {
  font-size: clamp(11px, 3.2vw, 12px);
  line-height: 18px;
  white-space: nowrap;
}

.wap-login-page .reset-field {
  width: 100%;
  margin: 0;
}

.wap-login-page .reset-account .reset-submit {
  margin-top: 105px;
}

.wap-login-page .reset-divider {
  margin: 28px 0 20px;
}

.wap-login-page .reset-code .code-field {
  display: block;
}

.wap-login-page .reset-code .login-subtitle {
  margin-bottom: 9px;
}

.wap-login-page .reset-resend {
  height: 20px;
  max-width: 190px;
  margin: 9px 0 0 auto;
  color: #87968C;
  font-size: 13px;
  line-height: 20px;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.wap-login-page .reset-code .reset-submit {
  margin-top: 78px;
}

.wap-login-page .reset-password h1 {
  margin-bottom: 60px;
}

.wap-login-page .reset-password .reset-field {
  margin-top: 0;
}

.wap-login-page .reset-password .reset-field + .reset-field {
  margin-top: 16px;
}

.wap-login-page .reset-password .reset-submit {
  margin-top: 44px;
}

.wap-login-page .reset-login-link {
  position: absolute;
  left: 50%;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 120px);
  height: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--wap-login-green);
  font-size: 13px;
  line-height: 20px;
  transform: translateX(-50%);
}

.wap-login-page .reset-login-prefix {
  color: var(--wap-login-text);
}

.wap-login-page .reset-login-action {
  color: var(--wap-login-green);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.wap-login-page .sms-consent {
  width: auto;
  top: auto;
  right: clamp(32px, 9.33vw, 43px);
  bottom: 16px;
  left: clamp(32px, 9.33vw, 43px);
  color: #686E6A;
  font-size: 11px;
  line-height: 16px;
}

@media (max-height: 760px) {
  .wap-login-page .register-tip {
    position: static;
    margin: 60px 0 24px;
  }

  .wap-login-page .reset-login-link {
    bottom: 62px;
  }
}

@media (max-width: 350px) {
  .wap-login-page .login-panel,
  .wap-login-page .login-panel.is-reset {
    padding-right: 24px;
    padding-left: 24px;
  }

  .wap-login-page .reset-back {
    left: 14px;
  }

  .wap-login-page .login-main h1,
  .wap-login-page .reset-main h1 {
    font-size: 22px;
  }
}
</style>
